/* Options:
Date: 2026-05-14 15:35:10
Version: 8.60
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:5001

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/

// @ts-nocheck
import { immerable } from "immer";

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IGet
{
}

export interface IHasSessionId
{
    sessionId?: string;
}

export interface IHasBearerToken
{
    bearerToken?: string;
}

export interface IPost
{
}

export interface IDelete
{
}

export enum Permissions
{
    ProjectsCanViewPage = 0,
    ProjectsCanAddProject = 1,
    ProjectsCanEditProject = 2,
    ProjectsCanSeeArchivedStages = 3,
    ProjectCanViewPage = 4,
    ProjectCanSeeArchivedStages = 5,
    ProjectCanAddStage = 6,
    ProjectCanEditStage = 7,
    ProjectCanDeleteStage = 8,
    ProjectCanEditPrecincts = 9,
    ProjectCanEditFinanceAttributes = 10,
    StageCanViewPage = 11,
    StageCanAddLot = 12,
    StageCanEditLot = 13,
    StageCanDeleteLot = 14,
    StageCanAddAttachment = 15,
    StageCanEditAttachment = 16,
    StageCanDeleteAttachment = 17,
    StageCanBulkEditLots = 18,
    StageCanBulkEditLotProperties = 19,
    StageCanBulkEditContracts = 20,
    StageCanCreatePricelist = 21,
    StageCanStylePricelist = 22,
    StageCanEditStagePlan = 23,
    StageCanEditFinanceAttributes = 24,
    LotCanViewPage = 25,
    LotCanAddProperty = 26,
    LotCanEditProperty = 27,
    LotCanAddNote = 28,
    LotCanEditNote = 29,
    LotCanDeleteNote = 30,
    LotCanAddAttachment = 31,
    LotCanEditAttachment = 32,
    LotCanDeleteAttachment = 33,
    LotCanAddContract = 34,
    LotCanEditContract = 35,
    LotCanDeleteContract = 36,
    ContractCanAction = 37,
    ReportsCanViewPage = 38,
    ReportsCanViewCustomReports = 39,
    ReportsCanViewProjectSummary = 40,
    ReportsCanViewLotSummary = 41,
    ReportsCanViewSalesAdviceOverdue = 42,
    ReportsCanViewCommission = 43,
    ReportsCanViewGrossRealisation = 44,
    ReportsCanViewSalesRate = 45,
    ReportsCanViewSalesAdviceToContract = 46,
    ReportsCanViewUpcomingSettlements = 47,
    ReportsCanViewStageLotCounts = 48,
    ReportsCanViewAssets = 49,
    ReportsCanViewFinances = 50,
    ReportsCanViewLotPricingComparison = 51,
    ReportsCanViewContractCancellationSummary = 52,
    AdminAccess = 53,
    CanSeeRealEstateStages = 54,
    SystemPrivileges = 55,
    ProjectCanEditCommissions = 56,
}

export enum ReportMailScheduleTypes
{
    Never = 0,
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
    Yearly = 4,
}

// @DataContract
export class Report
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public name?: string;

    // @DataMember(Order=3)
    public templateId?: number;

    // @DataMember(Order=4)
    public mailingList?: string;

    // @DataMember(Order=5)
    public ccList?: string;

    // @DataMember(Order=6)
    public scheduleType?: ReportMailScheduleTypes;

    public constructor(init?: Partial<Report>) { (Object as any).assign(this, init); }
}

export enum ReportTemplateTypes
{
    Pricelist = 1,
    SalesSummary = 2,
    LotSummary = 3,
    ContractsOverdue = 4,
    CommissionReport = 5,
    GrossRealisationReport = 6,
    SalesRateReport = 7,
    SalesAdviceToContract = 8,
    ProjectSalesHistory = 9,
    AssetValuation = 10,
    UpcomingSettlements = 11,
    StageLotCounts = 12,
    Finance = 13,
    Assets = 14,
    Custom = 15,
    EmailOnlySalesSummary = 16,
    EmailOnlyLotSummary = 17,
    LotPricingComparison = 18,
    ContractCancellationSummary = 19,
}

// @DataContract
export class ReportTemplate
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public name?: string;

    // @DataMember(Order=3)
    public templateType?: ReportTemplateTypes;

    public constructor(init?: Partial<ReportTemplate>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FileUploadTemporary implements IFileUploadTemporary
{
    [immerable] = true;

    // @DataMember(Order=1)
    public guid: string;

    // @DataMember(Order=2)
    public name: string;

    // @DataMember(Order=3)
    public extension: string;

    // @DataMember(Order=4)
    public fileSize?: number;

    // @DataMember(Order=5)
    public contentType: string;

    // @DataMember(Order=6)
    public image: boolean;

    public constructor(init?: Partial<FileUploadTemporary>) { (Object as any).assign(this, init); }
}

// @DataContract
export class File
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    // @Ignore()
    public fileName?: string;

    // @DataMember(Order=3)
    public formDefinitionId?: number;

    // @DataMember(Order=4)
    public formId?: number;

    // @DataMember(Order=5)
    public propertyName: string;

    // @DataMember(Order=6)
    public enteredDate?: string;

    // @DataMember(Order=7)
    public enteredBy: string;

    // @DataMember(Order=8)
    public modifiedDate?: string;

    // @DataMember(Order=9)
    public modifiedBy: string;

    // @DataMember(Order=10)
    // @Ignore()
    public upload: FileUploadTemporary;

    // @DataMember(Order=11)
    // @Ignore()
    public extension: string;

    // @DataMember(Order=12)
    // @Ignore()
    public fileSize?: number;

    // @DataMember(Order=13)
    // @Ignore()
    public contentType: string;

    // @DataMember(Order=14)
    // @Ignore()
    public exists: boolean;

    // @DataMember(Order=15)
    // @Ignore()
    public image: boolean;

    public constructor(init?: Partial<File>) { (Object as any).assign(this, init); }
}

export enum ProjectStatuses
{
    ReleasedToMarket = 1,
    Pipeline = 2,
    Archived = 3,
}

// @DataContract
export class PropertyValue
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public propertyId?: number;

    // @DataMember(Order=3)
    public name?: string;

    // @DataMember(Order=4)
    public value?: string;

    public constructor(init?: Partial<PropertyValue>) { (Object as any).assign(this, init); }
}

export enum LotStatuses
{
    Available = 1,
    OnHold = 2,
    ContractIssued = 3,
    ContractExchanged = 4,
    ContractSettled = 5,
    DisplayHome = 6,
    SalesAdviceIssued = 7,
    ComingSoon = 8,
    Unavailable = 9,
    Englobo = 10,
    Future = 11,
}

export enum LotSaleStatuses
{
    Available = 1,
    OnHold = 2,
    ComingSoon = 3,
    Englobo = 4,
    Future = 5,
    Unavailable = 6,
}

export enum SubStages
{
    A = 1,
    B = 2,
    C = 3,
    D = 4,
    E = 5,
    F = 6,
    G = 7,
    H = 8,
    I = 9,
    J = 10,
}

// @DataContract
export class Lot implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public stageId?: number;

    // @DataMember(Order=3)
    public number?: number;

    // @DataMember(Order=4)
    public advertisedPrice?: number;

    // @DataMember(Order=5)
    public dateOnMarket?: string;

    // @DataMember(Order=6)
    public onSale?: boolean;

    // @DataMember(Order=7)
    public displayHome?: boolean;

    // @DataMember(Order=8)
    public landValue?: number;

    // @DataMember(Order=9)
    public landValueDate?: string;

    // @DataMember(Order=10)
    public status?: LotStatuses;

    // @DataMember(Order=11)
    public saleStatus?: LotSaleStatuses;

    // @DataMember(Order=12)
    public approvedRebate?: number;

    // @DataMember(Order=13)
    public enteredDate?: string;

    // @DataMember(Order=14)
    public modifiedDate?: string;

    // @DataMember(Order=15)
    public modifiedBy?: string;

    // @DataMember(Order=16)
    public plotLeft?: number;

    // @DataMember(Order=17)
    public plotTop?: number;

    // @DataMember(Order=18)
    public feasibilityPrice?: number;

    // @DataMember(Order=19)
    public subStage?: SubStages;

    // @DataMember(Order=20)
    public repeat?: number;

    // @DataMember(Order=21)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=22)
    public parentFormId?: number;

    // @DataMember(Order=23)
    public enteredBy?: string;

    // @DataMember(Order=24)
    public proceeds?: number;

    // @DataMember(Order=25)
    public gst?: number;

    public constructor(init?: Partial<Lot>) { (Object as any).assign(this, init); }
}

export enum FormDefinitions
{
    Project = 1,
    Stage = 2,
    Lot = 3,
    Agent = 4,
    AgentLocation = 5,
    Asset = 6,
    AssetLocation = 7,
    AssetTenancy = 8,
    AssetValue = 9,
    Attachment = 10,
    Contract = 11,
    CostToComplete = 12,
    ExportTemplate = 13,
    LotProperty = 14,
    LotNote = 15,
    Precinct = 16,
    ProjectAgentLocation = 17,
    ProjectCommission = 18,
    ProjectPrecinct = 19,
    Property = 20,
    ProjectPropertyDefault = 21,
    PropertyDefault = 22,
    StagePricelist = 23,
    Tenant = 24,
    UserAgentLocation = 25,
    UserProject = 26,
    StagePropertyDefault = 27,
    AttachmentType = 28,
}

export enum ReportFilterTargetFields
{
    ProjectId = 1,
    StageId = 2,
    ContractExchangeDate = 3,
    ContractSettleDate = 4,
    StageSalesStatus = 5,
    CommissionTypeExchange = 6,
    LotStatus = 7,
    EmailOnlyParams = 8,
    ContractCancellationDate = 9,
}

// @DataContract
export class IdReportFilter implements IReportFilter
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public reportId?: number;

    // @DataMember(Order=3)
    public filterTargetField?: ReportFilterTargetFields;

    // @DataMember(Order=4)
    public filterId?: number;

    public constructor(init?: Partial<IdReportFilter>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DateRangeReportFilter implements IReportFilter
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public reportId?: number;

    // @DataMember(Order=3)
    public filterTargetField?: ReportFilterTargetFields;

    // @DataMember(Order=4)
    public startDate?: string;

    // @DataMember(Order=5)
    public endDate?: string;

    public constructor(init?: Partial<DateRangeReportFilter>) { (Object as any).assign(this, init); }
}

export enum TimeUnits
{
    Days = 1,
    Weeks = 2,
    Months = 3,
    Years = 4,
}

// @DataContract
export class RecencyReportFilter implements IReportFilter
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public reportId?: number;

    // @DataMember(Order=3)
    public filterTargetField?: ReportFilterTargetFields;

    // @DataMember(Order=4)
    public quantity?: number;

    // @DataMember(Order=5)
    public unit?: TimeUnits;

    public constructor(init?: Partial<RecencyReportFilter>) { (Object as any).assign(this, init); }
}

export enum ReportCustomTemplateFieldTypes
{
    ProjectName = 1,
    ProjectType = 2,
    ProjectStatus = 3,
    ProjectPercentShare = 4,
    ProjectDefaultBackOnMarket = 5,
    ProjectArchived = 6,
    ProjectCostPerLot = 7,
    ProjectValuation = 8,
    ProjectValuationDate = 9,
    ProjectDefaultCommission = 10,
    ProjectCompanyName = 11,
    ProjectDirectors = 12,
    ProjectPhoneNumbers = 13,
    ProjectAbn = 14,
    ProjectAcn = 15,
    StageName = 16,
    StageStatus = 17,
    StageDevelopmentStatus = 18,
    StagePrecinctName = 19,
    StageDaApprovedLots = 20,
    StageResidentialSites = 21,
    StageAdditionalLots = 22,
    StageSpecialLots = 23,
    StageComments = 24,
    StageReferStageName = 25,
    StageArea = 26,
    StageCostPerLot = 27,
    StageBudget = 28,
    StageRegistrationDate = 29,
    LotNumber = 30,
    LotAdvertisedPrice = 31,
    LotDateOnMarket = 32,
    LotOnSale = 33,
    LotDisplayHome = 34,
    LotLandValue = 35,
    LotLandValueDate = 36,
    LotSaleStatus = 37,
    LotApprovedRebate = 38,
    ContractDateBackOnMarket = 39,
    ContractPrice = 40,
    ContractRebate = 41,
    ContractIssueDate = 42,
    ContractExchangeDate = 43,
    ContractRateAdjustments = 44,
    ContractWaterAdjustments = 45,
    ContractLegalFees = 46,
    ContractCommission = 47,
    ContractGst = 48,
    ContractHalfInterest = 49,
    ContractExpectedSettleDate = 50,
    ContractActualSettleDate = 51,
    ContractDeposit = 52,
    ContractNoInterest = 53,
    ContractStatus = 54,
    AgentLocation = 55,
    AgentName = 56,
    LotProperty = 57,
}

// @DataContract
export class ReportCustomTemplateField
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public templateId?: number;

    // @DataMember(Order=3)
    public fieldType?: ReportCustomTemplateFieldTypes;

    // @DataMember(Order=4)
    public fieldReferenceId?: number;

    public constructor(init?: Partial<ReportCustomTemplateField>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagePlan
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public stageId?: number;

    // @DataMember(Order=3)
    public subStage?: SubStages;

    // @DataMember(Order=4)
    // @StringLength(256)
    public imageUrl?: string;

    // @DataMember(Order=5)
    public imageHeight?: number;

    // @DataMember(Order=6)
    public imageWidth?: number;

    // @DataMember(Order=7)
    public legendswapoverSize?: number;

    // @DataMember(Order=8)
    public overrideStagePlanLotWidth?: number;

    public constructor(init?: Partial<StagePlan>) { (Object as any).assign(this, init); }
}

export interface IUserGetSingle
{
    metadata: { [index:string]: Object; };
}

export interface ILookupGetCollectionByFormDefinitionId extends IGet
{
    formDefinitionId?: number;
}

export interface IConfigurationGetSingleById extends IGet
{
    id?: number;
}

export interface IConfigurationGetCollection extends IGet
{
    skip?: number;
    take?: number;
}

export interface IConfigurationGetSingleByCode extends IGet
{
    code: string;
}

export interface IDataGetSingleById extends IGet
{
    id?: number;
}

export interface IDataGetCollection extends IGet
{
    skip?: number;
    take?: number;
}

// @DataContract
export class Agent implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    // @StringLength(128)
    public name?: string;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public modifiedDate?: string;

    // @DataMember(Order=5)
    public modifiedBy?: string;

    // @DataMember(Order=6)
    public enteredBy?: string;

    // @DataMember(Order=7)
    public repeat?: number;

    // @DataMember(Order=8)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=9)
    public parentFormId?: number;

    public constructor(init?: Partial<Agent>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AgentLocation implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public agentId?: number;

    // @DataMember(Order=3)
    // @StringLength(128)
    public location?: string;

    // @DataMember(Order=4)
    // @StringLength(128)
    public updateFeed?: string;

    // @DataMember(Order=5)
    public enteredDate?: string;

    // @DataMember(Order=6)
    public modifiedDate?: string;

    // @DataMember(Order=7)
    public modifiedBy?: string;

    // @DataMember(Order=8)
    public enteredBy?: string;

    // @DataMember(Order=9)
    public repeat?: number;

    // @DataMember(Order=10)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=11)
    public parentFormId?: number;

    public constructor(init?: Partial<AgentLocation>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Asset implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    // @StringLength(128)
    public name?: string;

    // @DataMember(Order=3)
    // @StringLength(256)
    public address?: string;

    // @DataMember(Order=4)
    public enteredDate?: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public enteredBy?: string;

    // @DataMember(Order=7)
    public modifiedBy?: string;

    // @DataMember(Order=8)
    public bankValuation?: number;

    // @DataMember(Order=9)
    public bankValuationDate?: string;

    // @DataMember(Order=10)
    public directorsValuation?: number;

    // @DataMember(Order=11)
    public directorsValuationDate?: string;

    // @DataMember(Order=12)
    // @StringLength(256)
    public loanAccountId?: string;

    // @DataMember(Order=13)
    public repeat?: number;

    // @DataMember(Order=14)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=15)
    public parentFormId?: number;

    public constructor(init?: Partial<Asset>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetLocation implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public assetId?: number;

    // @DataMember(Order=3)
    // @StringLength(128)
    public name?: string;

    // @DataMember(Order=4)
    public area?: number;

    // @DataMember(Order=5)
    public carpark?: number;

    // @DataMember(Order=6)
    public enteredDate?: string;

    // @DataMember(Order=7)
    public modifiedDate?: string;

    // @DataMember(Order=8)
    public modifiedBy?: string;

    // @DataMember(Order=9)
    public enteredBy?: string;

    // @DataMember(Order=10)
    public repeat?: number;

    // @DataMember(Order=11)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=12)
    public parentFormId?: number;

    public constructor(init?: Partial<AssetLocation>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetTenancy implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public assetLocationId?: number;

    // @DataMember(Order=3)
    public tenantId?: number;

    // @DataMember(Order=4)
    public commence?: string;

    // @DataMember(Order=5)
    public rentCommence?: string;

    // @DataMember(Order=6)
    public expiry?: string;

    // @DataMember(Order=7)
    public term?: number;

    // @DataMember(Order=8)
    // @StringLength(128)
    public options?: string;

    // @DataMember(Order=9)
    // @StringLength(128)
    public review?: string;

    // @DataMember(Order=10)
    public rentalRate?: number;

    // @DataMember(Order=11)
    public carparkRent?: number;

    // @DataMember(Order=12)
    public outgoings?: number;

    // @DataMember(Order=13)
    public outgoingSpc?: number;

    // @DataMember(Order=14)
    public guaranteeHeld?: number;

    // @DataMember(Order=15)
    public guaranteeRequired?: number;

    // @DataMember(Order=16)
    // @StringLength(8000)
    public comments?: string;

    // @DataMember(Order=17)
    public enteredDate?: string;

    // @DataMember(Order=18)
    public modifiedDate?: string;

    // @DataMember(Order=19)
    public modifiedBy?: string;

    // @DataMember(Order=20)
    public enteredBy?: string;

    // @DataMember(Order=21)
    public repeat?: number;

    // @DataMember(Order=22)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=23)
    public parentFormId?: number;

    public constructor(init?: Partial<AssetTenancy>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetValue implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public assetId?: number;

    // @DataMember(Order=3)
    public date?: string;

    // @DataMember(Order=4)
    // @StringLength(128)
    public value?: string;

    // @DataMember(Order=5)
    public enteredDate?: string;

    // @DataMember(Order=6)
    public modifiedDate?: string;

    // @DataMember(Order=7)
    public modifiedBy?: string;

    // @DataMember(Order=8)
    public enteredBy?: string;

    // @DataMember(Order=9)
    public repeat?: number;

    // @DataMember(Order=10)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=11)
    public parentFormId?: number;

    public constructor(init?: Partial<AssetValue>) { (Object as any).assign(this, init); }
}

export enum AttachmentParentTypes
{
    Project = 1,
    Stage = 2,
    Lot = 3,
}

// @DataContract
export class Attachment implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public attachmentParentType?: AttachmentParentTypes;

    // @DataMember(Order=3)
    public attachmentParentId?: number;

    // @DataMember(Order=4)
    // @StringLength(128)
    public name?: string;

    // @DataMember(Order=5)
    // @Ignore()
    public file?: File;

    // @DataMember(Order=6)
    public enteredDate?: string;

    // @DataMember(Order=7)
    public enteredBy?: string;

    // @DataMember(Order=8)
    public modifiedDate?: string;

    // @DataMember(Order=9)
    public modifiedBy?: string;

    // @DataMember(Order=10)
    public notifyUpdate?: boolean;

    // @DataMember(Order=11)
    public attachmentTypeId?: number;

    // @DataMember(Order=12)
    public repeat?: number;

    // @DataMember(Order=13)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=14)
    public parentFormId?: number;

    public constructor(init?: Partial<Attachment>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AttachmentType implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public name?: string;

    // @DataMember(Order=3)
    public rank?: number;

    // @DataMember(Order=4)
    public repeat?: number;

    // @DataMember(Order=5)
    public enteredDate?: string;

    // @DataMember(Order=6)
    public enteredBy?: string;

    // @DataMember(Order=7)
    public modifiedDate?: string;

    // @DataMember(Order=8)
    public modifiedBy?: string;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    public constructor(init?: Partial<AttachmentType>) { (Object as any).assign(this, init); }
}

export enum ContractStatuses
{
    SalesAdvice = 0,
    ContractIssued = 1,
    ContractExchanged = 2,
    ContractSettled = 3,
    ContractCancelled = 4,
    ContractRecission = 5,
    ContractForfeited = 6,
}

// @DataContract
export class Contract implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public lotId?: number;

    // @DataMember(Order=3)
    public agentLocationId?: number;

    // @DataMember(Order=4)
    public price?: number;

    // @DataMember(Order=5)
    public rebate?: number;

    // @DataMember(Order=6)
    public issueDate?: string;

    // @DataMember(Order=7)
    public exchangeDate?: string;

    // @DataMember(Order=8)
    public rateAdjust?: number;

    // @DataMember(Order=9)
    public waterAdjust?: number;

    // @DataMember(Order=10)
    public legals?: number;

    // @DataMember(Order=11)
    public commission?: number;

    // @DataMember(Order=12)
    public halfInterest?: number;

    // @DataMember(Order=13)
    public expectedSettleDate?: string;

    // @DataMember(Order=14)
    public settleDate?: string;

    // @DataMember(Order=15)
    public deposit?: number;

    // @DataMember(Order=16)
    public dateBackOnMarket?: string;

    // @DataMember(Order=17)
    public noInterest?: boolean;

    // @DataMember(Order=18)
    public status?: ContractStatuses;

    // @DataMember(Order=19)
    public authorised?: boolean;

    // @DataMember(Order=20)
    public enteredDate?: string;

    // @DataMember(Order=21)
    public modifiedDate?: string;

    // @DataMember(Order=22)
    public enteredBy?: string;

    // @DataMember(Order=23)
    public modifiedBy?: string;

    // @DataMember(Order=24)
    public salesAdviceDate?: string;

    // @DataMember(Order=25)
    // @StringLength(128)
    public salesAdviceAddedBy?: string;

    // @DataMember(Order=26)
    // @StringLength(8000)
    public manualExpectedSettleDateNotes?: string;

    // @DataMember(Order=27)
    public repeat?: number;

    // @DataMember(Order=28)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=29)
    public parentFormId?: number;

    // @DataMember(Order=30)
    public calculatedCommission?: number;

    // @DataMember(Order=31)
    // @Ignore()
    public listPrice?: number;

    // @DataMember(Order=31)
    // @Ignore()
    public approvedRebate?: number;

    // @DataMember(Order=32)
    // @Ignore()
    public calculatedExpectedSettleDate?: string;

    // @DataMember(Order=33)
    public cancellationDate?: string;

    public constructor(init?: Partial<Contract>) { (Object as any).assign(this, init); }
}

export enum CostToCompleteTypes
{
    Payment = 0,
    Cost = 1,
}

// @DataContract
export class CostToComplete implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public stageId?: number;

    // @DataMember(Order=3)
    public costToCompleteType?: CostToCompleteTypes;

    // @DataMember(Order=4)
    public costdate?: string;

    // @DataMember(Order=5)
    public amount?: number;

    // @DataMember(Order=6)
    public enteredDate?: string;

    // @DataMember(Order=7)
    public modifiedDate?: string;

    // @DataMember(Order=8)
    public enteredBy?: string;

    // @DataMember(Order=9)
    public modifiedBy?: string;

    // @DataMember(Order=10)
    public repeat?: number;

    // @DataMember(Order=11)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=12)
    public parentFormId?: number;

    public constructor(init?: Partial<CostToComplete>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ExportTemplate implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    // @StringLength(256)
    public name?: string;

    // @DataMember(Order=3)
    // @StringLength(8000)
    public fields?: string;

    // @DataMember(Order=4)
    public enteredDate?: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public enteredBy?: string;

    // @DataMember(Order=7)
    public modifiedBy?: string;

    // @DataMember(Order=8)
    public repeat?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    public constructor(init?: Partial<ExportTemplate>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotNote implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public lotId?: number;

    // @DataMember(Order=3)
    // @StringLength(256)
    public noteText?: string;

    // @DataMember(Order=4)
    public enteredDate?: string;

    // @DataMember(Order=5)
    public enteredBy?: string;

    // @DataMember(Order=6)
    public modifiedDate?: string;

    // @DataMember(Order=7)
    public modifiedBy?: string;

    // @DataMember(Order=8)
    public deleted?: boolean;

    // @DataMember(Order=9)
    public repeat?: number;

    // @DataMember(Order=10)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=11)
    public parentFormId?: number;

    public constructor(init?: Partial<LotNote>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotProperty implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public lotId?: number;

    // @DataMember(Order=3)
    public propertyId?: number;

    // @DataMember(Order=4)
    // @StringLength(128)
    public value?: string;

    // @DataMember(Order=5)
    public enteredDate?: string;

    // @DataMember(Order=6)
    public modifiedDate?: string;

    // @DataMember(Order=7)
    public enteredBy?: string;

    // @DataMember(Order=8)
    public modifiedBy?: string;

    // @DataMember(Order=9)
    public repeat?: number;

    // @DataMember(Order=10)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=11)
    public parentFormId?: number;

    public constructor(init?: Partial<LotProperty>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Precinct implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    // @StringLength(255)
    public name?: string;

    // @DataMember(Order=3)
    public rank?: number;

    // @DataMember(Order=4)
    public enteredDate?: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public enteredBy?: string;

    // @DataMember(Order=7)
    public modifiedBy?: string;

    // @DataMember(Order=8)
    public repeat?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    public constructor(init?: Partial<Precinct>) { (Object as any).assign(this, init); }
}

export enum ProjectTypes
{
    Normal = 1,
    JointVenture = 2,
}

// @DataContract
export class Project implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    // @StringLength(128)
    public name?: string;

    // @DataMember(Order=3)
    public type?: ProjectTypes;

    // @DataMember(Order=4)
    public status?: ProjectStatuses;

    // @DataMember(Order=5)
    public percentShare?: number;

    // @DataMember(Order=6)
    public defaultBackOnMarket?: number;

    // @DataMember(Order=7)
    public archived?: boolean;

    // @DataMember(Order=8)
    public costPerLot?: number;

    // @DataMember(Order=9)
    public valuation?: number;

    // @DataMember(Order=10)
    public valuationDate?: string;

    // @DataMember(Order=11)
    public valuationEnglobo?: number;

    // @DataMember(Order=12)
    public valuationDateEnglobo?: string;

    // @DataMember(Order=13)
    public valuationPerLot?: number;

    // @DataMember(Order=14)
    public valuationDatePerLot?: string;

    // @DataMember(Order=15)
    public commission?: number;

    // @DataMember(Order=16)
    // @StringLength(128)
    public companyName?: string;

    // @DataMember(Order=17)
    // @StringLength(256)
    public directors?: string;

    // @DataMember(Order=18)
    // @StringLength(256)
    public phoneNumbers?: string;

    // @DataMember(Order=19)
    // @StringLength(128)
    public abn?: string;

    // @DataMember(Order=20)
    // @StringLength(128)
    public acn?: string;

    // @DataMember(Order=21)
    public contractReportDateDays?: number;

    // @DataMember(Order=22)
    public contractReportDateDaysRealEstate?: number;

    // @DataMember(Order=23)
    public enteredDate?: string;

    // @DataMember(Order=24)
    public modifiedDate?: string;

    // @DataMember(Order=25)
    // @StringLength(128)
    public modifiedBy?: string;

    // @DataMember(Order=26)
    public defaultSettleDays?: number;

    // @DataMember(Order=27)
    // @StringLength(256)
    public costToCompleteCurrent?: string;

    // @DataMember(Order=28)
    // @StringLength(256)
    public costToCompleteFuture?: string;

    // @DataMember(Order=29)
    // @StringLength(2)
    public sageProjectCode?: string;

    // @DataMember(Order=30)
    // @StringLength(255)
    public landowner?: string;

    // @DataMember(Order=31)
    // @StringLength(255)
    public developer?: string;

    // @DataMember(Order=32)
    // @StringLength(255)
    public developmentDirector?: string;

    // @DataMember(Order=33)
    // @StringLength(255)
    public projectManager?: string;

    // @DataMember(Order=34)
    public marginScheme?: boolean;

    // @DataMember(Order=35)
    public developerCharge?: number;

    // @DataMember(Order=36)
    public iaCommission?: number;

    // @DataMember(Order=37)
    public landownerPerLotRate?: number;

    // @DataMember(Order=38)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=39)
    public parentFormId?: number;

    // @DataMember(Order=40)
    public repeat?: number;

    // @DataMember(Order=41)
    public enteredBy?: string;

    public constructor(init?: Partial<Project>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectAgentLocation implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public projectId?: number;

    // @DataMember(Order=3)
    public agentLocationId?: number;

    // @DataMember(Order=4)
    public enteredDate?: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public enteredBy?: string;

    // @DataMember(Order=7)
    public modifiedBy?: string;

    // @DataMember(Order=8)
    public repeat?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    public constructor(init?: Partial<ProjectAgentLocation>) { (Object as any).assign(this, init); }
}

export enum CommissionValueTypes
{
    Percentage = 1,
    FlatRate = 2,
}

export enum CommissionTypes
{
    Exchange = 1,
    Settlement = 2,
}

// @DataContract
export class ProjectCommission implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public projectId?: number;

    // @DataMember(Order=3)
    public commissionValueType?: CommissionValueTypes;

    // @DataMember(Order=4)
    public commission?: number;

    // @DataMember(Order=5)
    public dateEffective?: string;

    // @DataMember(Order=6)
    public commissionType?: CommissionTypes;

    // @DataMember(Order=7)
    public enteredDate?: string;

    // @DataMember(Order=8)
    public modifiedDate?: string;

    // @DataMember(Order=9)
    public enteredBy?: string;

    // @DataMember(Order=10)
    public modifiedBy?: string;

    // @DataMember(Order=11)
    public repeat?: number;

    // @DataMember(Order=12)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=13)
    public parentFormId?: number;

    public constructor(init?: Partial<ProjectCommission>) { (Object as any).assign(this, init); }
}

export enum ProjectPrecinctApprovals
{
    Unzoned = 1,
    Zoned = 2,
}

// @DataContract
export class ProjectPrecinct implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public projectId?: number;

    // @DataMember(Order=3)
    // @StringLength(255)
    public name?: string;

    // @DataMember(Order=4)
    // @StringLength(2)
    public sageCode?: string;

    // @DataMember(Order=5)
    public precinctApproval?: ProjectPrecinctApprovals;

    // @DataMember(Order=6)
    public enteredDate?: string;

    // @DataMember(Order=7)
    public modifiedDate?: string;

    // @DataMember(Order=8)
    public enteredBy?: string;

    // @DataMember(Order=9)
    public modifiedBy?: string;

    // @DataMember(Order=10)
    public repeat?: number;

    // @DataMember(Order=11)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=12)
    public parentFormId?: number;

    public constructor(init?: Partial<ProjectPrecinct>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectPropertyDefault implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public projectId?: number;

    // @DataMember(Order=3)
    public propertyDefaultId?: number;

    // @DataMember(Order=4)
    public enteredDate?: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public enteredBy?: string;

    // @DataMember(Order=7)
    public modifiedBy?: string;

    // @DataMember(Order=8)
    public repeat?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    public constructor(init?: Partial<ProjectPropertyDefault>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Property implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    // @StringLength(128)
    public name?: string;

    // @DataMember(Order=3)
    public rank?: number;

    // @DataMember(Order=4)
    public enteredDate?: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public enteredBy?: string;

    // @DataMember(Order=7)
    public modifiedBy?: string;

    // @DataMember(Order=8)
    public repeat?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    public constructor(init?: Partial<Property>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PropertyDefault implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public propertyid?: number;

    // @DataMember(Order=3)
    // @StringLength(128)
    public value?: string;

    // @DataMember(Order=4)
    public enteredDate?: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public enteredBy?: string;

    // @DataMember(Order=7)
    public modifiedBy?: string;

    // @DataMember(Order=8)
    public repeat?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    public constructor(init?: Partial<PropertyDefault>) { (Object as any).assign(this, init); }
}

export enum StageStatuses
{
    Unzoned = 1,
    Zoned = 2,
    DaApproved = 3,
    CcApproved = 4,
    UnderConstruction = 5,
    Registered = 6,
}

export enum StageDevelopmentStatuses
{
    DevelopmentConsent = 1,
    ConstructionCertificate = 2,
    UnderConstruction = 3,
    DevelopedLots = 4,
    Unzoned = 5,
    Zoned = 6,
}

export enum StageSalesStatuses
{
    Englobo = 0,
    Future = 1,
    Current = 2,
    Archived = 3,
}

export enum StageRegistrationDateBases
{
    Forecast = 1,
    Actual = 2,
}

// @DataContract
export class Stage implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public projectId?: number;

    // @DataMember(Order=3)
    // @StringLength(256)
    public name?: string;

    // @DataMember(Order=4)
    public status?: StageStatuses;

    // @DataMember(Order=5)
    public developmentStatus?: StageDevelopmentStatuses;

    // @DataMember(Order=6)
    public precinctId?: number;

    // @DataMember(Order=7)
    public daApprovedLots?: number;

    // @DataMember(Order=8)
    public residentialSites?: number;

    // @DataMember(Order=9)
    public additionalLots?: number;

    // @DataMember(Order=10)
    public specialLots?: number;

    // @DataMember(Order=11)
    // @StringLength(256)
    public comments?: string;

    // @DataMember(Order=12)
    public referStage?: number;

    // @DataMember(Order=13)
    public area?: number;

    // @DataMember(Order=14)
    public costPerLot?: number;

    // @DataMember(Order=15)
    public budget?: number;

    // @DataMember(Order=16)
    public registrationDate?: string;

    // @DataMember(Order=17)
    public enteredDate?: string;

    // @DataMember(Order=18)
    public modifiedDate?: string;

    // @DataMember(Order=19)
    // @StringLength(128)
    public modifiedBy?: string;

    // @DataMember(Order=20)
    // @StringLength(256)
    public imageUrl?: string;

    // @DataMember(Order=21)
    public imageHeight?: number;

    // @DataMember(Order=22)
    public imageWidth?: number;

    // @DataMember(Order=23)
    public valuationPerLot?: number;

    // @DataMember(Order=24)
    public salesStatus?: StageSalesStatuses;

    // @DataMember(Order=25)
    // @StringLength(9)
    public sageJobCostCode?: string;

    // @DataMember(Order=26)
    public overrideStagePlanLotWidth?: number;

    // @DataMember(Order=27)
    public registrationDateBasis?: StageRegistrationDateBases;

    // @DataMember(Order=28)
    public contractSunsetDate?: string;

    // @DataMember(Order=29)
    public legendSwapoverSize?: number;

    // @DataMember(Order=30)
    // @StringLength(3)
    public sageStageCode?: string;

    // @DataMember(Order=31)
    public feasibilityPrice?: number;

    // @DataMember(Order=32)
    public projectPrecinctId?: number;

    // @DataMember(Order=33)
    public gmPercent?: number;

    // @DataMember(Order=34)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=35)
    public parentFormId?: number;

    // @DataMember(Order=36)
    public repeat?: number;

    // @DataMember(Order=37)
    public enteredBy?: string;

    public constructor(init?: Partial<Stage>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagePricelist implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public stageId?: number;

    // @DataMember(Order=3)
    // @StringLength(256)
    public name?: string;

    // @DataMember(Order=4)
    // @Ignore()
    public file?: File;

    // @DataMember(Order=5)
    // @StringLength(256)
    public headerFont?: string;

    // @DataMember(Order=6)
    // @StringLength(256)
    public rowFont?: string;

    // @DataMember(Order=7)
    public headerTextSize?: number;

    // @DataMember(Order=8)
    public rowTextSize?: number;

    // @DataMember(Order=9)
    // @StringLength(6)
    public headerTextColor?: string;

    // @DataMember(Order=10)
    // @StringLength(6)
    public rowTextColor?: string;

    // @DataMember(Order=11)
    public headerBold?: boolean;

    // @DataMember(Order=12)
    public textBold?: boolean;

    // @DataMember(Order=13)
    public startX: number;

    // @DataMember(Order=14)
    public startY: number;

    // @DataMember(Order=15)
    public headerHeight?: number;

    // @DataMember(Order=16)
    public rowHeight?: number;

    // @DataMember(Order=17)
    public orientation?: number;

    // @DataMember(Order=18)
    public maxLots?: number;

    // @DataMember(Order=19)
    public lotsPerColumn?: number;

    // @DataMember(Order=20)
    // @StringLength(6)
    public headerBackColor?: string;

    // @DataMember(Order=21)
    // @StringLength(6)
    public rowColor?: string;

    // @DataMember(Order=22)
    // @StringLength(6)
    public altRowColor?: string;

    // @DataMember(Order=23)
    public showBorders?: boolean;

    // @DataMember(Order=24)
    public headerSeparators?: boolean;

    // @DataMember(Order=25)
    public footerBorder?: boolean;

    // @DataMember(Order=26)
    // @StringLength(6)
    public borderColor?: string;

    // @DataMember(Order=27)
    public borderSize: number;

    // @DataMember(Order=28)
    public enteredDate?: string;

    // @DataMember(Order=29)
    public modifiedDate?: string;

    // @DataMember(Order=30)
    public modifiedBy?: string;

    // @DataMember(Order=31)
    public enteredBy?: string;

    // @DataMember(Order=32)
    public subStage?: SubStages;

    // @DataMember(Order=33)
    public repeat?: number;

    // @DataMember(Order=34)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=35)
    public parentFormId?: number;

    public constructor(init?: Partial<StagePricelist>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagePropertyDefault implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public stageId?: number;

    // @DataMember(Order=3)
    public propertyDefaultId?: number;

    // @DataMember(Order=4)
    public enteredDate?: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public enteredBy?: string;

    // @DataMember(Order=7)
    public modifiedBy?: string;

    // @DataMember(Order=8)
    public repeat?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    public constructor(init?: Partial<StagePropertyDefault>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Tenant implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    // @StringLength(128)
    public name?: string;

    // @DataMember(Order=3)
    public rank?: number;

    // @DataMember(Order=4)
    public enteredDate?: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public enteredBy?: string;

    // @DataMember(Order=7)
    public modifiedBy?: string;

    // @DataMember(Order=8)
    public repeat?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    public constructor(init?: Partial<Tenant>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserAgentLocation implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public userId?: number;

    // @DataMember(Order=3)
    public agentLocationId?: number;

    // @DataMember(Order=4)
    public username?: string;

    // @DataMember(Order=5)
    public enteredDate?: string;

    // @DataMember(Order=6)
    public modifiedDate?: string;

    // @DataMember(Order=7)
    public enteredBy?: string;

    // @DataMember(Order=8)
    public modifiedBy?: string;

    // @DataMember(Order=9)
    public repeat?: number;

    // @DataMember(Order=10)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=11)
    public parentFormId?: number;

    public constructor(init?: Partial<UserAgentLocation>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserProject implements IForm
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public userId?: number;

    // @DataMember(Order=3)
    public projectId?: number;

    // @DataMember(Order=4)
    public username?: string;

    // @DataMember(Order=5)
    public enteredDate?: string;

    // @DataMember(Order=6)
    public modifiedDate?: string;

    // @DataMember(Order=7)
    public enteredBy?: string;

    // @DataMember(Order=8)
    public modifiedBy?: string;

    // @DataMember(Order=9)
    public repeat?: number;

    // @DataMember(Order=10)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=11)
    public parentFormId?: number;

    public constructor(init?: Partial<UserProject>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    [immerable] = true;

    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    [immerable] = true;

    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AgentLocationSummary
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public agentName?: string;

    // @DataMember(Order=3)
    public location?: string;

    public constructor(init?: Partial<AgentLocationSummary>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AgentPersonnelSummary
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public agentName?: string;

    // @DataMember(Order=3)
    public location?: string;

    // @DataMember(Order=4)
    public personnel?: string;

    public constructor(init?: Partial<AgentPersonnelSummary>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AgentProjectSummary
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public agentName?: string;

    // @DataMember(Order=3)
    public location?: string;

    // @DataMember(Order=4)
    public projectName?: string;

    public constructor(init?: Partial<AgentProjectSummary>) { (Object as any).assign(this, init); }
}

export enum ApiEnabledStatus
{
    Active = 1,
    Inactive = 2,
    Unused = 3,
}

export class SentrySettings
{
    [immerable] = true;

    public dsn?: string;
    public environment?: string;
    public customer?: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export class ClientAppSettings
{
    [immerable] = true;

    public sentry?: SentrySettings;

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ContractSummary
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public status?: ContractStatuses;

    // @DataMember(Order=3)
    public price?: number;

    // @DataMember(Order=4)
    public exchangeDate?: string;

    // @DataMember(Order=5)
    public rateAdjustments?: number;

    // @DataMember(Order=6)
    public legalFees?: number;

    // @DataMember(Order=7)
    public commission?: number;

    // @DataMember(Order=8)
    public halfShareInterest?: number;

    // @DataMember(Order=9)
    public agentName?: string;

    // @DataMember(Order=10)
    public settlementDate?: string;

    public constructor(init?: Partial<ContractSummary>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FinancesCurrentFutureRow
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public projectName?: string;

    // @DataMember(Order=3)
    public stageName?: string;

    // @DataMember(Order=4)
    public unsold?: number;

    // @DataMember(Order=5)
    public contractsIssued?: number;

    // @DataMember(Order=6)
    public contractsExchanged?: number;

    // @DataMember(Order=7)
    public unsoldIssuedValue?: number;

    // @DataMember(Order=8)
    public exchangedValue?: number;

    // @DataMember(Order=9)
    public month1?: number;

    // @DataMember(Order=10)
    public month2?: number;

    // @DataMember(Order=11)
    public month3?: number;

    // @DataMember(Order=12)
    public month4?: number;

    public constructor(init?: Partial<FinancesCurrentFutureRow>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FinancesEngloboLandProject
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public projectName?: string;

    // @DataMember(Order=3)
    public stageName?: string;

    // @DataMember(Order=4)
    public unsold?: number;

    // @DataMember(Order=5)
    public assetValue?: number;

    public constructor(init?: Partial<FinancesEngloboLandProject>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotChangeDetail
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    // @References("typeof(PTS.ServiceLogic.Models.Do.LotChange)")
    public changeid?: number;

    // @DataMember(Order=3)
    // @StringLength(128)
    public field?: string;

    // @DataMember(Order=4)
    // @StringLength(128)
    public oldValue?: string;

    // @DataMember(Order=5)
    // @StringLength(128)
    public newValue?: string;

    public constructor(init?: Partial<LotChangeDetail>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotChange
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public lotId?: number;

    // @DataMember(Order=3)
    // @StringLength(128)
    public tableName?: string;

    // @DataMember(Order=4)
    public changedBy?: string;

    // @DataMember(Order=5)
    public changeTime?: string;

    // @DataMember(Order=6)
    public details?: LotChangeDetail[];

    public constructor(init?: Partial<LotChange>) { (Object as any).assign(this, init); }
}

export class LotPropertyBulkEditRow
{
    [immerable] = true;

    public lotId?: number;
    public properties?: LotProperty[];

    public constructor(init?: Partial<LotPropertyBulkEditRow>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotSummary
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public lotNo?: number;

    // @DataMember(Order=3)
    public status?: LotStatuses;

    // @DataMember(Order=4)
    public listPrice?: number;

    // @DataMember(Order=5)
    public contractPrice?: number;

    // @DataMember(Order=6)
    public contractCount?: number;

    // @DataMember(Order=7)
    public contractIssueDate?: string;

    // @DataMember(Order=8)
    public contractExchangeDate?: string;

    // @DataMember(Order=9)
    public rateAdjustments?: number;

    // @DataMember(Order=10)
    public legalFees?: number;

    // @DataMember(Order=11)
    public commission?: number;

    // @DataMember(Order=12)
    public halfInterest?: number;

    // @DataMember(Order=13)
    public agentName?: string;

    // @DataMember(Order=14)
    public settlementDate?: string;

    // @DataMember(Order=15)
    public settlementProceeds?: number;

    // @DataMember(Order=16)
    public subStage?: SubStages;

    public constructor(init?: Partial<LotSummary>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectSummary
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public name?: string;

    // @DataMember(Order=3)
    public status?: ProjectStatuses;

    // @DataMember(Order=4)
    public future?: number;

    // @DataMember(Order=5)
    public unavailable?: number;

    // @DataMember(Order=6)
    public comingSoon?: number;

    // @DataMember(Order=7)
    public onHold?: number;

    // @DataMember(Order=8)
    public available?: number;

    // @DataMember(Order=9)
    public salesAdviceIssued?: number;

    // @DataMember(Order=10)
    public contractIssued?: number;

    // @DataMember(Order=11)
    public contractExchanged?: number;

    // @DataMember(Order=12)
    public contractSettled?: number;

    // @DataMember(Order=13)
    public totalLots?: number;

    public constructor(init?: Partial<ProjectSummary>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ApiLotResult
{
    [immerable] = true;

    // @DataMember(Order=1)
    public lotNumber?: number;

    // @DataMember(Order=2)
    public lotStatus?: string;

    public constructor(init?: Partial<ApiLotResult>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ReportCustomTemplateFieldWithName
{
    [immerable] = true;

    // @DataMember(Order=1)
    public field: ReportCustomTemplateField;

    // @DataMember(Order=2)
    public name: string;

    public constructor(init?: Partial<ReportCustomTemplateFieldWithName>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EmailOnlySalesSummaryStage
{
    [immerable] = true;

    // @DataMember(Order=1)
    public name?: string;

    // @DataMember(Order=2)
    public totalSales?: number;

    // @DataMember(Order=3)
    public totalListPrice?: number;

    // @DataMember(Order=4)
    public totalContractPrice?: number;

    public constructor(init?: Partial<EmailOnlySalesSummaryStage>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EmailOnlySalesSummaryProject
{
    [immerable] = true;

    // @DataMember(Order=1)
    public name?: string;

    // @DataMember(Order=2)
    public totalSales?: number;

    // @DataMember(Order=3)
    public totalListPrice?: number;

    // @DataMember(Order=4)
    public totalContractPrice?: number;

    // @DataMember(Order=5)
    public stages?: EmailOnlySalesSummaryStage[];

    public constructor(init?: Partial<EmailOnlySalesSummaryProject>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EmailOnlySalesSummaryTable
{
    [immerable] = true;

    // @DataMember(Order=1)
    public name?: string;

    // @DataMember(Order=2)
    public totalSales?: number;

    // @DataMember(Order=3)
    public totalListPrice?: number;

    // @DataMember(Order=4)
    public totalContractPrice?: number;

    // @DataMember(Order=5)
    public projects?: EmailOnlySalesSummaryProject[];

    public constructor(init?: Partial<EmailOnlySalesSummaryTable>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EmailOnlyLotSummaryProject
{
    [immerable] = true;

    // @DataMember(Order=1)
    public name?: string;

    // @DataMember(Order=2)
    public available?: number;

    // @DataMember(Order=3)
    public contractsIssued?: number;

    // @DataMember(Order=4)
    public exchanged?: number;

    // @DataMember(Order=5)
    public exchangedValue?: number;

    // @DataMember(Order=6)
    public settled?: number;

    // @DataMember(Order=7)
    public future?: number;

    // @DataMember(Order=8)
    public totalLotYield?: number;

    public constructor(init?: Partial<EmailOnlyLotSummaryProject>) { (Object as any).assign(this, init); }
}

export enum StagePlanPlotPointStatuses
{
    ForSale = 1,
    DepositTaken = 2,
    Sold = 3,
    OnHold = 4,
    ComingSoon = 5,
}

// @DataContract
export class StagePlanPlotPoint
{
    [immerable] = true;

    // @DataMember(Order=1)
    public lotNumber?: number;

    // @DataMember(Order=2)
    public lotId?: number;

    // @DataMember(Order=3)
    public x?: number;

    // @DataMember(Order=4)
    public y?: number;

    // @DataMember(Order=5)
    public status?: StagePlanPlotPointStatuses;

    // @DataMember(Order=6)
    public size?: string;

    // @DataMember(Order=7)
    public frontage?: string;

    // @DataMember(Order=8)
    public description?: string;

    public constructor(init?: Partial<StagePlanPlotPoint>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StageSummary
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public name?: string;

    // @DataMember(Order=3)
    public status?: StageStatuses;

    // @DataMember(Order=4)
    public future?: number;

    // @DataMember(Order=5)
    public unavailable?: number;

    // @DataMember(Order=6)
    public comingSoon?: number;

    // @DataMember(Order=7)
    public onHold?: number;

    // @DataMember(Order=8)
    public available?: number;

    // @DataMember(Order=9)
    public salesAdviceIssued?: number;

    // @DataMember(Order=10)
    public contractIssued?: number;

    // @DataMember(Order=11)
    public contractExchanged?: number;

    // @DataMember(Order=12)
    public contractSettled?: number;

    // @DataMember(Order=13)
    public totalLots?: number;

    // @DataMember(Order=14)
    public unsoldLotValue?: number;

    // @DataMember(Order=15)
    public exchangedLotValue?: number;

    // @DataMember(Order=16)
    public settledLotValue?: number;

    public constructor(init?: Partial<StageSummary>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserProjectSummary
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public personnel?: string;

    // @DataMember(Order=3)
    public location?: string;

    public constructor(init?: Partial<UserProjectSummary>) { (Object as any).assign(this, init); }
}

export interface IFileUploadTemporary
{
    guid: string;
    name: string;
    extension: string;
    fileSize?: number;
    contentType: string;
    image: boolean;
}

// @DataContract
export class User implements IUserDto
{
    [immerable] = true;

    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public userName: string;

    // @DataMember(Order=3)
    public displayName: string;

    // @DataMember(Order=4)
    public sessionId: string;

    public constructor(init?: Partial<User>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LookupItem
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: Object;

    // @DataMember(Order=2)
    public value?: string;

    // @DataMember(Order=3)
    public order?: number;

    // @DataMember(Order=4)
    public projectId?: number;

    public constructor(init?: Partial<LookupItem>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Lookup
{
    [immerable] = true;

    // @DataMember(Order=1)
    public propertyName?: string;

    // @DataMember(Order=2)
    public items?: LookupItem[];

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}

export class FormMetadata
{
    [immerable] = true;

    public formDefinitionId?: number;
    public formDefinitionCode: string;
    public name: string;
    public propertyName: string;
    public title: string;
    public instructions: string;

    public constructor(init?: Partial<FormMetadata>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormType implements IFormType
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public code: string;

    // @DataMember(Order=3)
    public name: string;

    public constructor(init?: Partial<FormType>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinition
{
    [immerable] = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public code: string;

    // @DataMember(Order=3)
    public type?: number;

    // @DataMember(Order=4)
    public name: string;

    // @DataMember(Order=5)
    public instructions: string;

    public constructor(init?: Partial<FormDefinition>) { (Object as any).assign(this, init); }
}

export enum ValidationResultType
{
    Valid = 1,
    Low = 2,
    Normal = 3,
    High = 4,
    Critical = 5,
}

export enum ValidationErrorType
{
    Warning = 1,
    Low = 2,
    Normal = 3,
    High = 4,
    Critical = 5,
}

// @DataContract
export class ValidationError implements IValidationError
{
    [immerable] = true;

    // @DataMember(Order=1)
    public property: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public detailedMessage: string;

    // @DataMember(Order=4)
    public code: string;

    // @DataMember(Order=5)
    public ruleSet: string;

    // @DataMember(Order=6)
    public type?: ValidationErrorType;

    public constructor(init?: Partial<ValidationError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ValidationResult
{
    [immerable] = true;

    // @DataMember(Order=1)
    public result: ValidationResultType;

    // @DataMember(Order=2)
    public errors: ValidationError[];

    // @DataMember(Order=3)
    public metadata: { [index:string]: Object; };

    public constructor(init?: Partial<ValidationResult>) { (Object as any).assign(this, init); }
}

export interface IFile extends IDataModel, IHasFormDefinitionId, IHasFormId, IFileUpload
{
    propertyName: string;
}

export interface IDataModel extends IModel, IHasAudit
{
}

export interface IModel
{
    id?: number;
}

export interface IHasAudit
{
    enteredDate?: string;
    enteredBy: string;
    modifiedDate?: string;
    modifiedBy: string;
}

export interface IHasFormDefinitionId
{
    formDefinitionId?: number;
}

export interface IHasFormId
{
    formId?: number;
}

export interface IFileUpload
{
    extension: string;
    fileSize?: number;
    contentType: string;
    exists: boolean;
    image: boolean;
    upload: IFileUploadTemporary;
}

export interface IForm extends IDataModel, IHasParentFormDefinitionId, IHasParentFormId
{
    repeat?: number;
}

export interface IHasParentFormDefinitionId
{
    parentFormDefinitionId?: number;
}

export interface IHasParentFormId
{
    parentFormId?: number;
}

export interface IReportFilter
{
    id?: number;
    reportId?: number;
    filterTargetField?: ReportFilterTargetFields;
}

export interface IUserDto
{
    userId: string;
    userName: string;
    displayName: string;
    sessionId: string;
}

export interface ILookupItem
{
    id: Object;
    value: Object;
    order: Object;
}

export interface ILookup
{
    propertyName: string;
    items: ILookupItem[];
}

export interface IFormType extends IConfigurationModel, IHasCode
{
    name: string;
}

export interface IConfigurationModel extends IModel
{
}

export interface IHasCode
{
    code: string;
}

export interface IFormDefinitionPropertyErrorMessage extends IConfigurationModel, IHasFormDefinitionPropertyId
{
    errorCode: string;
    message: string;
    detailedMessage: string;
    type?: ValidationErrorType;
}

export interface IFormDefinitionProperty extends IConfigurationModel, IHasFormDefinitionId
{
    propertyName: string;
    label: string;
    detailedLabel: string;
    errorMessages: IFormDefinitionPropertyErrorMessage[];
}

export interface IFormDefinition extends IConfigurationModel, IHasCode
{
    type?: number;
    name: string;
    instructions: string;
    properties: IFormDefinitionProperty[];
    subformProperties: { [index:string]: IFormDefinitionProperty[]; };
}

export interface IValidationError
{
    property: string;
    message: string;
    detailedMessage: string;
    code: string;
    type?: ValidationErrorType;
}

export interface IValidationResult
{
    metadata: { [index:string]: Object; };
    result: ValidationResultType;
    errors: IValidationError[];
}

export interface IHasFormDefinitionPropertyId
{
    formDefinitionPropertyId?: number;
}

export class AgentGetAsCollectionResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public agents?: Agent[];

    public constructor(init?: Partial<AgentGetAsCollectionResponse>) { (Object as any).assign(this, init); }
}

export class AgentLocationSummaryGetCollectionResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public agentLocationSummaries?: AgentLocationSummary[];

    public constructor(init?: Partial<AgentLocationSummaryGetCollectionResponse>) { (Object as any).assign(this, init); }
}

export class AgentPersonnelSummaryGetCollectionResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public agentPersonnelSummaries?: AgentPersonnelSummary[];

    public constructor(init?: Partial<AgentPersonnelSummaryGetCollectionResponse>) { (Object as any).assign(this, init); }
}

export class AgentProjectSummaryGetCollectionResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public agentProjectSummaries?: AgentProjectSummary[];

    public constructor(init?: Partial<AgentProjectSummaryGetCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ApiManagementUpdateStatusResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ApiManagementUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ApiGetEnabledStatusResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public status?: ApiEnabledStatus;

    public constructor(init?: Partial<ApiGetEnabledStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DeleteSingleResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<DeleteSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AttachmentGetCollectionByLotIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public attachments?: Attachment[];

    public constructor(init?: Partial<AttachmentGetCollectionByLotIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AttachmentGetCollectionByStageIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public attachments?: Attachment[];

    public constructor(init?: Partial<AttachmentGetCollectionByStageIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AttachmentGetCollectionByProjectIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public attachments?: Attachment[];

    public constructor(init?: Partial<AttachmentGetCollectionByProjectIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AttachmentTypeGetAsCollectionResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public attachmentTypes?: AttachmentType[];

    public constructor(init?: Partial<AttachmentTypeGetAsCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticationCheckPermissionsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AuthenticationCheckPermissionsResponse>) { (Object as any).assign(this, init); }
}

export class AuthenticationGetPermissionsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public permissions: Permissions[] = [];

    public constructor(init?: Partial<AuthenticationGetPermissionsResponse>) { (Object as any).assign(this, init); }
}

export class GetClientAppSettingsResponse
{
    [immerable] = true;

    public settings?: ClientAppSettings;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetClientAppSettingsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ContractGetSummaryCollectionByLotIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public contractSummaries?: ContractSummary[];

    public constructor(init?: Partial<ContractGetSummaryCollectionByLotIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ContractGetCollectionByStageIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public contracts?: Contract[];

    public constructor(init?: Partial<ContractGetCollectionByStageIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ContractGetMinExchangeDateByProjectIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public minExchangeDate?: string;

    public constructor(init?: Partial<ContractGetMinExchangeDateByProjectIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SendEmailsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SendEmailsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FinancesGetByProjectIdProjectStatusResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public currentLots?: FinancesCurrentFutureRow[];

    // @DataMember(Order=3)
    public futureLots?: FinancesCurrentFutureRow[];

    // @DataMember(Order=4)
    public engloboLandProjects?: FinancesEngloboLandProject[];

    public constructor(init?: Partial<FinancesGetByProjectIdProjectStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotChangeGetCollectionByLotIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public lotChanges?: LotChange[];

    public constructor(init?: Partial<LotChangeGetCollectionByLotIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotNoteGetCollectionByLotIdResponse
{
    [immerable] = true;

    // @DataMember(Order=2)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public lotNotes?: LotNote[];

    public constructor(init?: Partial<LotNoteGetCollectionByLotIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotPropertyBEGetCollectionByProjectIdStageIdPropertyIdsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public lotPropertyBulkEditRows?: LotPropertyBulkEditRow[];

    public constructor(init?: Partial<LotPropertyBEGetCollectionByProjectIdStageIdPropertyIdsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotPropertyPostRowEditResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public data: LotProperty;

    public constructor(init?: Partial<LotPropertyPostRowEditResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotPropertyPostBulkEditResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public data: LotProperty[] = [];

    public constructor(init?: Partial<LotPropertyPostBulkEditResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotPropertyGetCollectionByStageIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public data?: LotProperty[];

    public constructor(init?: Partial<LotPropertyGetCollectionByStageIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotGetCollectionByProjectIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public data: Lot[] = [];

    // @DataMember(Order=3)
    public count?: number;

    public constructor(init?: Partial<LotGetCollectionByProjectIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotGetStatusCountsByProjectIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public future?: number;

    // @DataMember(Order=3)
    public unavailable?: number;

    // @DataMember(Order=4)
    public comingSoon?: number;

    // @DataMember(Order=5)
    public onHold?: number;

    // @DataMember(Order=6)
    public available?: number;

    // @DataMember(Order=7)
    public salesAdviceIssued?: number;

    // @DataMember(Order=8)
    public contractIssued?: number;

    // @DataMember(Order=9)
    public contractExchanged?: number;

    // @DataMember(Order=10)
    public contractSettled?: number;

    public constructor(init?: Partial<LotGetStatusCountsByProjectIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotSummaryGetCollectionByStageIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public lotSummaries?: LotSummary[];

    public constructor(init?: Partial<LotSummaryGetCollectionByStageIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotGetSummaryByProjectIdStageIdLotIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public projectName?: string;

    // @DataMember(Order=3)
    public stageName?: string;

    // @DataMember(Order=2)
    public lotNo?: number;

    // @DataMember(Order=3)
    public status?: LotStatuses;

    // @DataMember(Order=4)
    public price?: number;

    // @DataMember(Order=5)
    public releaseDate?: string;

    // @DataMember(Order=6)
    public properties?: PropertyValue[];

    public constructor(init?: Partial<LotGetSummaryByProjectIdStageIdLotIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotGetCollectionByStageIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public data: Lot[] = [];

    public constructor(init?: Partial<LotGetCollectionByStageIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotPostBulkUpdateCoordsByStageIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<LotPostBulkUpdateCoordsByStageIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PrecinctGetAsCollectionResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public precincts?: Precinct[];

    public constructor(init?: Partial<PrecinctGetAsCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectCommissionGetCollectionByProjectIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public projectCommissions?: ProjectCommission[];

    public constructor(init?: Partial<ProjectCommissionGetCollectionByProjectIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectPrecinctGetCollectionByProjectIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public projectPrecincts?: ProjectPrecinct[];

    public constructor(init?: Partial<ProjectPrecinctGetCollectionByProjectIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectGetCollectionByStatusResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public projects?: Project[];

    // @DataMember(Order=3)
    public count?: number;

    public constructor(init?: Partial<ProjectGetCollectionByStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectGetViewableCollectionResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public projects?: Project[];

    public constructor(init?: Partial<ProjectGetViewableCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectSummaryGetCollectionResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public projectSummaries?: ProjectSummary[];

    public constructor(init?: Partial<ProjectSummaryGetCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectGetDetailsByIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public project?: Project;

    // @DataMember(Order=3)
    public futureStageLots?: number;

    // @DataMember(Order=4)
    public currentStageLots?: number;

    // @DataMember(Order=5)
    public futureStageValue?: number;

    // @DataMember(Order=6)
    public currentStageValue?: number;

    // @DataMember(Order=7)
    public futureStageCompletionCost?: number;

    public constructor(init?: Partial<ProjectGetDetailsByIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PropertyGetAsCollectionResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public properties?: Property[];

    public constructor(init?: Partial<PropertyGetAsCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ApiGetLotsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public lots: ApiLotResult[] = [];

    public constructor(init?: Partial<ApiGetLotsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ReportGetTemplatesResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public reportTemplates?: ReportTemplate[];

    public constructor(init?: Partial<ReportGetTemplatesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ReportGetCustomFieldsResponse
{
    [immerable] = true;

    // @DataMember
    public responseStatus?: ResponseStatus;

    // @DataMember
    public data?: ReportCustomTemplateFieldWithName[];

    public constructor(init?: Partial<ReportGetCustomFieldsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ReportTemplateGetByIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public reportTemplate?: ReportTemplate;

    public constructor(init?: Partial<ReportTemplateGetByIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ReportTemplateGetFieldsByTemplateIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public fields?: ReportCustomTemplateField[];

    public constructor(init?: Partial<ReportTemplateGetFieldsByTemplateIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ReportTemplatePostSaveResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ReportTemplatePostSaveResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ReportPostSaveResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ReportPostSaveResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ReportGetCollectionResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public data?: Report[];

    public constructor(init?: Partial<ReportGetCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ReportGetPreviewResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public report?: Report;

    // @DataMember(Order=3)
    public summaries?: { [index:string]: string; }[];

    // @DataMember(Order=4)
    public rows?: { [index:string]: string; }[];

    public constructor(init?: Partial<ReportGetPreviewResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ReportGetSingleByIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public report?: Report;

    // @DataMember(Order=3)
    public idFilters?: IdReportFilter[];

    // @DataMember(Order=4)
    public dateRangeFilters?: DateRangeReportFilter[];

    // @DataMember(Order=5)
    public recencyFilters?: RecencyReportFilter[];

    public constructor(init?: Partial<ReportGetSingleByIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ReportTemplatePreviewResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public template?: ReportTemplate;

    // @DataMember(Order=3)
    public summaries?: { [index:string]: string; }[];

    // @DataMember(Order=4)
    public rows?: { [index:string]: string; }[];

    public constructor(init?: Partial<ReportTemplatePreviewResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EmailOnlySalesSummaryGetDataByReportIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public reportTables?: EmailOnlySalesSummaryTable[];

    public constructor(init?: Partial<EmailOnlySalesSummaryGetDataByReportIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EmailOnlyLotSummaryGetDataByReportIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public totalAvailable?: number;

    // @DataMember(Order=3)
    public totalContractsIssued?: number;

    // @DataMember(Order=4)
    public totalExchanged?: number;

    // @DataMember(Order=5)
    public totalExchangedValue?: number;

    // @DataMember(Order=6)
    public totalSettled?: number;

    // @DataMember(Order=7)
    public totalFuture?: number;

    // @DataMember(Order=8)
    public totalLotYield?: number;

    // @DataMember(Order=9)
    public projects?: EmailOnlyLotSummaryProject[];

    public constructor(init?: Partial<EmailOnlyLotSummaryGetDataByReportIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagePlanGetSingleByStageIdSubStageResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public stagePlan?: StagePlan;

    public constructor(init?: Partial<StagePlanGetSingleByStageIdSubStageResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagePlanGetPointsByStageIdSubStageResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public plotPoints?: StagePlanPlotPoint[];

    public constructor(init?: Partial<StagePlanGetPointsByStageIdSubStageResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagePlanPostSaveResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<StagePlanPostSaveResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagePricelistGetByStageIdSubStageResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public data: StagePricelist;

    public constructor(init?: Partial<StagePricelistGetByStageIdSubStageResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PricelistGetSubstagesByStageIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public subStages?: SubStages[];

    public constructor(init?: Partial<PricelistGetSubstagesByStageIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StageGetCollectionByProjectIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public data?: Stage[];

    // @DataMember(Order=3)
    public total?: number;

    public constructor(init?: Partial<StageGetCollectionByProjectIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StageGetCollectionByProjectIdsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public stages?: Stage[];

    public constructor(init?: Partial<StageGetCollectionByProjectIdsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StageGetSummaryCollectionByProjectIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public stageSummaries?: StageSummary[];

    public constructor(init?: Partial<StageGetSummaryCollectionByProjectIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StageGetSummaryByProjectIdStageIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public stage?: Stage;

    // @DataMember(Order=3)
    public projectName?: string;

    // @DataMember(Order=4)
    public totalLots?: number;

    // @DataMember(Order=5)
    public comingSoon?: number;

    // @DataMember(Order=6)
    public onHold?: number;

    // @DataMember(Order=7)
    public available?: number;

    // @DataMember(Order=8)
    public salesAdviceIssued?: number;

    // @DataMember(Order=9)
    public contractsIssued?: number;

    // @DataMember(Order=10)
    public contractsExchanged?: number;

    // @DataMember(Order=11)
    public contractsSettled?: number;

    // @DataMember(Order=12)
    public totalListPrice?: number;

    // @DataMember(Order=13)
    public averageListPrice?: number;

    // @DataMember(Order=14)
    public totalSettledContractPrice?: number;

    // @DataMember(Order=15)
    public averageSettledContractPrice?: number;

    // @DataMember(Order=16)
    public totalUnsettledContractPrice?: number;

    // @DataMember(Order=17)
    public averageUnsettledContractPrice?: number;

    // @DataMember(Order=18)
    public totalExchangedContractPrice?: number;

    public constructor(init?: Partial<StageGetSummaryByProjectIdStageIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StageGetSubStagesByStageIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public subStages?: SubStages[];

    public constructor(init?: Partial<StageGetSubStagesByStageIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TenantGetAsCollectionResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public tenants?: Tenant[];

    public constructor(init?: Partial<TenantGetAsCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserProjectSummaryGetCollectionResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public userProjectSummaries?: UserProjectSummary[];

    public constructor(init?: Partial<UserProjectSummaryGetCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ScriptedReportUpdateMailingListsResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ScriptedReportUpdateMailingListsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UtilityEmailGetStringsByReportIdResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public toList?: string;

    // @DataMember(Order=3)
    public ccList?: string;

    public constructor(init?: Partial<UtilityEmailGetStringsByReportIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    [immerable] = true;

    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public refreshTokenExpiry?: string;

    // @DataMember(Order=9)
    public profileUrl: string;

    // @DataMember(Order=10)
    public roles: string[];

    // @DataMember(Order=11)
    public permissions: string[];

    // @DataMember(Order=12)
    public authProvider: string;

    // @DataMember(Order=13)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=14)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    [immerable] = true;

    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

export class UploadResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public upload: IFileUploadTemporary;

    public constructor(init?: Partial<UploadResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved user. */
    // @DataMember(Order=2)
    public user: User;

    public constructor(init?: Partial<UserSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LookupCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved lookups. */
    // @DataMember(Order=2)
    public lookups: Lookup[];

    public constructor(init?: Partial<LookupCollectionResponse>) { (Object as any).assign(this, init); }
}

export class GetFormMetadataResponse
{
    [immerable] = true;

    public responseStatus: ResponseStatus;
    public formMetadata: FormMetadata[];

    public constructor(init?: Partial<GetFormMetadataResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormTypeSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved form type. */
    // @DataMember(Order=2)
    public configuration: FormType;

    public constructor(init?: Partial<FormTypeSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormTypeCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved form types. */
    // @DataMember(Order=2)
    public configuration: FormType[];

    public constructor(init?: Partial<FormTypeCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved form definition. */
    // @DataMember(Order=2)
    public configuration: FormDefinition;

    public constructor(init?: Partial<FormDefinitionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved form definitions. */
    // @DataMember(Order=2)
    public configuration: FormDefinition[];

    public constructor(init?: Partial<FormDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AgentSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved agent. */
    // @DataMember(Order=2)
    public data: Agent;

    public constructor(init?: Partial<AgentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AgentCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved agents. */
    // @DataMember(Order=2)
    public data: Agent[];

    public constructor(init?: Partial<AgentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AgentValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<AgentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AgentLocationSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved agent location. */
    // @DataMember(Order=2)
    public data: AgentLocation;

    public constructor(init?: Partial<AgentLocationSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AgentLocationCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved agent locations. */
    // @DataMember(Order=2)
    public data: AgentLocation[];

    public constructor(init?: Partial<AgentLocationCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AgentLocationValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<AgentLocationValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved asset. */
    // @DataMember(Order=2)
    public data: Asset;

    public constructor(init?: Partial<AssetSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved assets. */
    // @DataMember(Order=2)
    public data: Asset[];

    public constructor(init?: Partial<AssetCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<AssetValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetLocationSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved asset location. */
    // @DataMember(Order=2)
    public data: AssetLocation;

    public constructor(init?: Partial<AssetLocationSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetLocationCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved asset locations. */
    // @DataMember(Order=2)
    public data: AssetLocation[];

    public constructor(init?: Partial<AssetLocationCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetLocationValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<AssetLocationValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetTenancySingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved asset tenancy. */
    // @DataMember(Order=2)
    public data: AssetTenancy;

    public constructor(init?: Partial<AssetTenancySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetTenancyCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved asset tenancys. */
    // @DataMember(Order=2)
    public data: AssetTenancy[];

    public constructor(init?: Partial<AssetTenancyCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetTenancyValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<AssetTenancyValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetValueSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved asset value. */
    // @DataMember(Order=2)
    public data: AssetValue;

    public constructor(init?: Partial<AssetValueSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetValueCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved asset values. */
    // @DataMember(Order=2)
    public data: AssetValue[];

    public constructor(init?: Partial<AssetValueCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssetValueValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<AssetValueValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AttachmentSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved attachment. */
    // @DataMember(Order=2)
    public data: Attachment;

    public constructor(init?: Partial<AttachmentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AttachmentCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved attachments. */
    // @DataMember(Order=2)
    public data: Attachment[];

    public constructor(init?: Partial<AttachmentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AttachmentValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<AttachmentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AttachmentTypeSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved attachment type. */
    // @DataMember(Order=2)
    public data: AttachmentType;

    public constructor(init?: Partial<AttachmentTypeSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AttachmentTypeCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved attachment types. */
    // @DataMember(Order=2)
    public data: AttachmentType[];

    public constructor(init?: Partial<AttachmentTypeCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AttachmentTypeValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<AttachmentTypeValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ContractSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved contract. */
    // @DataMember(Order=2)
    public data: Contract;

    public constructor(init?: Partial<ContractSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ContractCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved contracts. */
    // @DataMember(Order=2)
    public data: Contract[];

    public constructor(init?: Partial<ContractCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ContractValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<ContractValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CostToCompleteSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved cost to complete. */
    // @DataMember(Order=2)
    public data: CostToComplete;

    public constructor(init?: Partial<CostToCompleteSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CostToCompleteCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved cost to completes. */
    // @DataMember(Order=2)
    public data: CostToComplete[];

    public constructor(init?: Partial<CostToCompleteCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CostToCompleteValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<CostToCompleteValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ExportTemplateSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved export template. */
    // @DataMember(Order=2)
    public data: ExportTemplate;

    public constructor(init?: Partial<ExportTemplateSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ExportTemplateCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved export templates. */
    // @DataMember(Order=2)
    public data: ExportTemplate[];

    public constructor(init?: Partial<ExportTemplateCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ExportTemplateValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<ExportTemplateValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved lot. */
    // @DataMember(Order=2)
    public data: Lot;

    public constructor(init?: Partial<LotSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved lots. */
    // @DataMember(Order=2)
    public data: Lot[];

    public constructor(init?: Partial<LotCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<LotValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotNoteSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved lot note. */
    // @DataMember(Order=2)
    public data: LotNote;

    public constructor(init?: Partial<LotNoteSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotNoteCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved lot notes. */
    // @DataMember(Order=2)
    public data: LotNote[];

    public constructor(init?: Partial<LotNoteCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotNoteValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<LotNoteValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotPropertySingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved lot property. */
    // @DataMember(Order=2)
    public data: LotProperty;

    public constructor(init?: Partial<LotPropertySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotPropertyCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved lot propertys. */
    // @DataMember(Order=2)
    public data: LotProperty[];

    public constructor(init?: Partial<LotPropertyCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LotPropertyValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<LotPropertyValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PrecinctSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved precinct. */
    // @DataMember(Order=2)
    public data: Precinct;

    public constructor(init?: Partial<PrecinctSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PrecinctCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved precincts. */
    // @DataMember(Order=2)
    public data: Precinct[];

    public constructor(init?: Partial<PrecinctCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PrecinctValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<PrecinctValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved project. */
    // @DataMember(Order=2)
    public data: Project;

    public constructor(init?: Partial<ProjectSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved projects. */
    // @DataMember(Order=2)
    public data: Project[];

    public constructor(init?: Partial<ProjectCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<ProjectValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectAgentLocationSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved project agent location. */
    // @DataMember(Order=2)
    public data: ProjectAgentLocation;

    public constructor(init?: Partial<ProjectAgentLocationSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectAgentLocationCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved project agent locations. */
    // @DataMember(Order=2)
    public data: ProjectAgentLocation[];

    public constructor(init?: Partial<ProjectAgentLocationCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectAgentLocationValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<ProjectAgentLocationValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectCommissionSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved project commission. */
    // @DataMember(Order=2)
    public data: ProjectCommission;

    public constructor(init?: Partial<ProjectCommissionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectCommissionCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved project commissions. */
    // @DataMember(Order=2)
    public data: ProjectCommission[];

    public constructor(init?: Partial<ProjectCommissionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectCommissionValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<ProjectCommissionValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectPrecinctSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved project precinct. */
    // @DataMember(Order=2)
    public data: ProjectPrecinct;

    public constructor(init?: Partial<ProjectPrecinctSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectPrecinctCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved project precincts. */
    // @DataMember(Order=2)
    public data: ProjectPrecinct[];

    public constructor(init?: Partial<ProjectPrecinctCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectPrecinctValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<ProjectPrecinctValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectPropertyDefaultSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved project property default. */
    // @DataMember(Order=2)
    public data: ProjectPropertyDefault;

    public constructor(init?: Partial<ProjectPropertyDefaultSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectPropertyDefaultCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved project property defaults. */
    // @DataMember(Order=2)
    public data: ProjectPropertyDefault[];

    public constructor(init?: Partial<ProjectPropertyDefaultCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProjectPropertyDefaultValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<ProjectPropertyDefaultValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PropertySingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved property. */
    // @DataMember(Order=2)
    public data: Property;

    public constructor(init?: Partial<PropertySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PropertyCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved propertys. */
    // @DataMember(Order=2)
    public data: Property[];

    public constructor(init?: Partial<PropertyCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PropertyValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<PropertyValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PropertyDefaultSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved property default. */
    // @DataMember(Order=2)
    public data: PropertyDefault;

    public constructor(init?: Partial<PropertyDefaultSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PropertyDefaultCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved property defaults. */
    // @DataMember(Order=2)
    public data: PropertyDefault[];

    public constructor(init?: Partial<PropertyDefaultCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PropertyDefaultValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<PropertyDefaultValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StageSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved stage. */
    // @DataMember(Order=2)
    public data: Stage;

    public constructor(init?: Partial<StageSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StageCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved stages. */
    // @DataMember(Order=2)
    public data: Stage[];

    public constructor(init?: Partial<StageCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StageValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<StageValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagePricelistSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved stage pricelist. */
    // @DataMember(Order=2)
    public data: StagePricelist;

    public constructor(init?: Partial<StagePricelistSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagePricelistCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved stage pricelists. */
    // @DataMember(Order=2)
    public data: StagePricelist[];

    public constructor(init?: Partial<StagePricelistCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagePricelistValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<StagePricelistValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagePropertyDefaultSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved stage property default. */
    // @DataMember(Order=2)
    public data: StagePropertyDefault;

    public constructor(init?: Partial<StagePropertyDefaultSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagePropertyDefaultCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved stage property defaults. */
    // @DataMember(Order=2)
    public data: StagePropertyDefault[];

    public constructor(init?: Partial<StagePropertyDefaultCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StagePropertyDefaultValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<StagePropertyDefaultValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TenantSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved tenant. */
    // @DataMember(Order=2)
    public data: Tenant;

    public constructor(init?: Partial<TenantSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TenantCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved tenants. */
    // @DataMember(Order=2)
    public data: Tenant[];

    public constructor(init?: Partial<TenantCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TenantValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<TenantValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserAgentLocationSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved user agent location. */
    // @DataMember(Order=2)
    public data: UserAgentLocation;

    public constructor(init?: Partial<UserAgentLocationSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserAgentLocationCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved user agent locations. */
    // @DataMember(Order=2)
    public data: UserAgentLocation[];

    public constructor(init?: Partial<UserAgentLocationCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserAgentLocationValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<UserAgentLocationValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserProjectSingleResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved user project. */
    // @DataMember(Order=2)
    public data: UserProject;

    public constructor(init?: Partial<UserProjectSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserProjectCollectionResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved user projects. */
    // @DataMember(Order=2)
    public data: UserProject[];

    public constructor(init?: Partial<UserProjectCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserProjectValidationResponse
{
    [immerable] = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: ValidationResult;

    public constructor(init?: Partial<UserProjectValidationResponse>) { (Object as any).assign(this, init); }
}

export class AgentGetAsCollection implements IReturn<AgentGetAsCollectionResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<AgentGetAsCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentGetAsCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AgentGetAsCollectionResponse(); }
}

export class AgentLocationSummaryGetCollection implements IReturn<AgentLocationSummaryGetCollectionResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<AgentLocationSummaryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentLocationSummaryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AgentLocationSummaryGetCollectionResponse(); }
}

export class AgentPersonnelSummaryGetCollection implements IReturn<AgentPersonnelSummaryGetCollectionResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<AgentPersonnelSummaryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentPersonnelSummaryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AgentPersonnelSummaryGetCollectionResponse(); }
}

export class AgentProjectSummaryGetCollection implements IReturn<AgentProjectSummaryGetCollectionResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<AgentProjectSummaryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentProjectSummaryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AgentProjectSummaryGetCollectionResponse(); }
}

// @DataContract
export class ApiManagementUpdateStatusByStageId implements IReturn<ApiManagementUpdateStatusResponse>, IPost
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    // @DataMember(Order=2)
    public isActive?: boolean;

    public constructor(init?: Partial<ApiManagementUpdateStatusByStageId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ApiManagementUpdateStatusByStageId'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ApiManagementUpdateStatusResponse(); }
}

// @DataContract
export class ApiGetEnabledStatusByStageId implements IReturn<ApiGetEnabledStatusResponse>, IGet
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    public constructor(init?: Partial<ApiGetEnabledStatusByStageId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ApiGetEnabledStatusByStageId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ApiGetEnabledStatusResponse(); }
}

// @DataContract
export class ApiManagementUpdateStatusByProjectId implements IReturn<ApiManagementUpdateStatusResponse>, IPost
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    // @DataMember(Order=2)
    public isActive?: boolean;

    public constructor(init?: Partial<ApiManagementUpdateStatusByProjectId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ApiManagementUpdateStatusByProjectId'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ApiManagementUpdateStatusResponse(); }
}

// @DataContract
export class ApiGetEnabledStatusByProjectId implements IReturn<ApiGetEnabledStatusResponse>, IGet
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    public constructor(init?: Partial<ApiGetEnabledStatusByProjectId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ApiGetEnabledStatusByProjectId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ApiGetEnabledStatusResponse(); }
}

// @DataContract
export class AssetDeleteSingleById implements IReturn<DeleteSingleResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public assetId?: number;

    public constructor(init?: Partial<AssetDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteSingleResponse(); }
}

// @DataContract
export class AttachmentDeleteSingleById implements IReturn<DeleteSingleResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public attachmentId?: number;

    public constructor(init?: Partial<AttachmentDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteSingleResponse(); }
}

// @DataContract
export class AttachmentGetCollectionByLotId implements IReturn<AttachmentGetCollectionByLotIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public lotId?: number;

    public constructor(init?: Partial<AttachmentGetCollectionByLotId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentGetCollectionByLotId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AttachmentGetCollectionByLotIdResponse(); }
}

// @DataContract
export class AttachmentGetCollectionByStageId implements IReturn<AttachmentGetCollectionByStageIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    public constructor(init?: Partial<AttachmentGetCollectionByStageId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentGetCollectionByStageId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AttachmentGetCollectionByStageIdResponse(); }
}

// @DataContract
export class AttachmentGetCollectionByProjectId implements IReturn<AttachmentGetCollectionByProjectIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    public constructor(init?: Partial<AttachmentGetCollectionByProjectId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentGetCollectionByProjectId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AttachmentGetCollectionByProjectIdResponse(); }
}

// @DataContract
export class AttachmentTypeGetAsCollection implements IReturn<AttachmentTypeGetAsCollectionResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<AttachmentTypeGetAsCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentTypeGetAsCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AttachmentTypeGetAsCollectionResponse(); }
}

// @DataContract
export class AuthenticationCheckAdminPermissions implements IReturn<AuthenticationCheckPermissionsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public permissions: Permissions;

    public constructor(init?: Partial<AuthenticationCheckAdminPermissions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AuthenticationCheckAdminPermissions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AuthenticationCheckPermissionsResponse(); }
}

// @DataContract
export class AuthenticationGetPermissions implements IReturn<AuthenticationGetPermissionsResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<AuthenticationGetPermissions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AuthenticationGetPermissions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AuthenticationGetPermissionsResponse(); }
}

export class GetClientAppSettings implements IReturn<GetClientAppSettingsResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<GetClientAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetClientAppSettingsResponse(); }
}

// @DataContract
export class ContractGetSummaryCollectionByLotId implements IReturn<ContractGetSummaryCollectionByLotIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public lotId?: number;

    public constructor(init?: Partial<ContractGetSummaryCollectionByLotId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContractGetSummaryCollectionByLotId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ContractGetSummaryCollectionByLotIdResponse(); }
}

// @DataContract
export class ContractGetCollectionByStageId implements IReturn<ContractGetCollectionByStageIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    public constructor(init?: Partial<ContractGetCollectionByStageId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContractGetCollectionByStageId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ContractGetCollectionByStageIdResponse(); }
}

// @DataContract
export class ContractGetMinExchangeDateByProjectId implements IReturn<ContractGetMinExchangeDateByProjectIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    public constructor(init?: Partial<ContractGetMinExchangeDateByProjectId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContractGetMinExchangeDateByProjectId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ContractGetMinExchangeDateByProjectIdResponse(); }
}

// @DataContract
export class SendScheduledEmails implements IReturn<SendEmailsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public scheduleType: ReportMailScheduleTypes;

    public constructor(init?: Partial<SendScheduledEmails>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendScheduledEmails'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendEmailsResponse(); }
}

// @DataContract
export class SendCsvReportEmail implements IReturn<SendEmailsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public report?: Report;

    // @DataMember(Order=2)
    public template?: ReportTemplate;

    public constructor(init?: Partial<SendCsvReportEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendCsvReportEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendEmailsResponse(); }
}

// @DataContract
export class SendEmailOnlyReportEmail implements IReturn<SendEmailsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public report?: Report;

    // @DataMember(Order=2)
    public template?: ReportTemplate;

    public constructor(init?: Partial<SendEmailOnlyReportEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendEmailOnlyReportEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendEmailsResponse(); }
}

// @DataContract
export class FileRegisterInDatabase implements IReturnVoid
{
    [immerable] = true;

    // @DataMember(Order=1)
    public file?: File;

    public constructor(init?: Partial<FileRegisterInDatabase>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FileRegisterInDatabase'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @DataContract
export class FinancesGetByProjectIdProjectStatus implements IReturn<FinancesGetByProjectIdProjectStatusResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    // @DataMember(Order=2)
    public projectStatus?: ProjectStatuses;

    public constructor(init?: Partial<FinancesGetByProjectIdProjectStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinancesGetByProjectIdProjectStatus'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FinancesGetByProjectIdProjectStatusResponse(); }
}

// @DataContract
export class LotChangeGetCollectionByLotId implements IReturn<LotChangeGetCollectionByLotIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public lotId?: number;

    public constructor(init?: Partial<LotChangeGetCollectionByLotId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotChangeGetCollectionByLotId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotChangeGetCollectionByLotIdResponse(); }
}

// @DataContract
export class LotNoteDeleteSingleById implements IReturn<DeleteSingleResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public lotNoteId?: number;

    public constructor(init?: Partial<LotNoteDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotNoteDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteSingleResponse(); }
}

// @DataContract
export class LotNoteGetCollectionByLotId implements IReturn<LotNoteGetCollectionByLotIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public lotId?: number;

    public constructor(init?: Partial<LotNoteGetCollectionByLotId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotNoteGetCollectionByLotId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotNoteGetCollectionByLotIdResponse(); }
}

// @DataContract
export class LotPropertyBEGetCollectionByProjectIdStageIdPropertyIds implements IReturn<LotPropertyBEGetCollectionByProjectIdStageIdPropertyIdsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    // @DataMember(Order=2)
    public stageId?: number;

    // @DataMember(Order=3)
    public propertyIds?: number[];

    public constructor(init?: Partial<LotPropertyBEGetCollectionByProjectIdStageIdPropertyIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotPropertyBEGetCollectionByProjectIdStageIdPropertyIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotPropertyBEGetCollectionByProjectIdStageIdPropertyIdsResponse(); }
}

// @DataContract
export class LotPropertyPostRowEdit implements IReturn<LotPropertyPostRowEditResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public lotId?: number;

    // @DataMember(Order=2)
    public propertyId?: number;

    // @DataMember(Order=3)
    public value?: string;

    public constructor(init?: Partial<LotPropertyPostRowEdit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotPropertyPostRowEdit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LotPropertyPostRowEditResponse(); }
}

// @DataContract
export class LotPropertyPostBulkEdit implements IReturn<LotPropertyPostBulkEditResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public lotIds?: number[];

    // @DataMember(Order=2)
    public propertyValues?: PropertyValue[];

    public constructor(init?: Partial<LotPropertyPostBulkEdit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotPropertyPostBulkEdit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LotPropertyPostBulkEditResponse(); }
}

// @DataContract
export class LotPropertyGetCollectionByStageId implements IReturn<LotPropertyGetCollectionByStageIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    public constructor(init?: Partial<LotPropertyGetCollectionByStageId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotPropertyGetCollectionByStageId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotPropertyGetCollectionByStageIdResponse(); }
}

// @DataContract
export class LotDeleteSingleById implements IReturn<DeleteSingleResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public lotId?: number;

    public constructor(init?: Partial<LotDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteSingleResponse(); }
}

// @DataContract
export class LotGetCollectionByProjectId implements IReturn<LotGetCollectionByProjectIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    // @DataMember(Order=2)
    public skip?: number;

    // @DataMember(Order=3)
    public take?: number;

    public constructor(init?: Partial<LotGetCollectionByProjectId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotGetCollectionByProjectId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotGetCollectionByProjectIdResponse(); }
}

export class LotGetStatusCountsByProjectId implements IReturn<LotGetStatusCountsByProjectIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    public constructor(init?: Partial<LotGetStatusCountsByProjectId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotGetStatusCountsByProjectId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotGetStatusCountsByProjectIdResponse(); }
}

// @DataContract
export class LotSummaryGetCollectionByStageId implements IReturn<LotSummaryGetCollectionByStageIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    public constructor(init?: Partial<LotSummaryGetCollectionByStageId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotSummaryGetCollectionByStageId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotSummaryGetCollectionByStageIdResponse(); }
}

// @DataContract
export class LotGetSummaryByProjectIdStageIdLotId implements IReturn<LotGetSummaryByProjectIdStageIdLotIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    // @DataMember(Order=2)
    public stageId?: number;

    // @DataMember(Order=3)
    public lotId?: number;

    public constructor(init?: Partial<LotGetSummaryByProjectIdStageIdLotId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotGetSummaryByProjectIdStageIdLotId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotGetSummaryByProjectIdStageIdLotIdResponse(); }
}

// @DataContract
export class LotGetCollectionByStageId implements IReturn<LotGetCollectionByStageIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    public constructor(init?: Partial<LotGetCollectionByStageId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotGetCollectionByStageId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotGetCollectionByStageIdResponse(); }
}

// @DataContract
export class LotPostBulkUpdateCoordsByStageId implements IReturn<LotPostBulkUpdateCoordsByStageIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    // @DataMember(Order=2)
    public lots?: Lot[];

    public constructor(init?: Partial<LotPostBulkUpdateCoordsByStageId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotPostBulkUpdateCoordsByStageId'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LotPostBulkUpdateCoordsByStageIdResponse(); }
}

// @DataContract
export class TypeDtoRequest
{
    [immerable] = true;

    // @DataMember(Order=1)
    public formDefinitions?: FormDefinitions;

    // @DataMember(Order=2)
    public idReportFilter?: IdReportFilter;

    // @DataMember(Order=3)
    public dateRangeReportFilter?: DateRangeReportFilter;

    // @DataMember(Order=4)
    public recencyReportFilter?: RecencyReportFilter;

    public constructor(init?: Partial<TypeDtoRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TypeDtoRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @DataContract
export class PrecinctGetAsCollection implements IReturn<PrecinctGetAsCollectionResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<PrecinctGetAsCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrecinctGetAsCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PrecinctGetAsCollectionResponse(); }
}

// @DataContract
export class ProjectCommissionGetCollectionByProjectId implements IReturn<ProjectCommissionGetCollectionByProjectIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    public constructor(init?: Partial<ProjectCommissionGetCollectionByProjectId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectCommissionGetCollectionByProjectId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectCommissionGetCollectionByProjectIdResponse(); }
}

// @DataContract
export class ProjectPrecinctGetCollectionByProjectId implements IReturn<ProjectPrecinctGetCollectionByProjectIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    public constructor(init?: Partial<ProjectPrecinctGetCollectionByProjectId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPrecinctGetCollectionByProjectId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectPrecinctGetCollectionByProjectIdResponse(); }
}

// @DataContract
export class ProjectGetCollectionByStatus implements IReturn<ProjectGetCollectionByStatusResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public status?: ProjectStatuses;

    // @DataMember(Order=2)
    public skip?: number;

    // @DataMember(Order=3)
    public take?: number;

    public constructor(init?: Partial<ProjectGetCollectionByStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectGetCollectionByStatus'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectGetCollectionByStatusResponse(); }
}

// @DataContract
export class ProjectGetViewableCollection implements IReturn<ProjectGetViewableCollectionResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<ProjectGetViewableCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectGetViewableCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectGetViewableCollectionResponse(); }
}

// @DataContract
export class ProjectSummaryGetCollection implements IReturn<ProjectSummaryGetCollectionResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public showArchivedStages?: boolean;

    public constructor(init?: Partial<ProjectSummaryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectSummaryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectSummaryGetCollectionResponse(); }
}

// @DataContract
export class ProjectGetDetailsById implements IReturn<ProjectGetDetailsByIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    // @DataMember(Order=2)
    public showArchivedStages?: boolean;

    public constructor(init?: Partial<ProjectGetDetailsById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectGetDetailsById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectGetDetailsByIdResponse(); }
}

// @DataContract
export class PropertyGetAsCollection implements IReturn<PropertyGetAsCollectionResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<PropertyGetAsCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PropertyGetAsCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PropertyGetAsCollectionResponse(); }
}

// @DataContract
export class ApiGetLotsByStageId implements IReturn<ApiGetLotsResponse>, IGet
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    public constructor(init?: Partial<ApiGetLotsByStageId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ApiGetLotsByStageId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ApiGetLotsResponse(); }
}

// @DataContract
export class ApiGetLotsByProjectId implements IReturn<ApiGetLotsResponse>, IGet
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    public constructor(init?: Partial<ApiGetLotsByProjectId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ApiGetLotsByProjectId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ApiGetLotsResponse(); }
}

// @DataContract
export class ReportGetTemplates implements IReturn<ReportGetTemplatesResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<ReportGetTemplates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportGetTemplates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ReportGetTemplatesResponse(); }
}

// @DataContract
export class ReportGetCustomFields implements IReturn<ReportGetCustomFieldsResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<ReportGetCustomFields>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportGetCustomFields'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ReportGetCustomFieldsResponse(); }
}

// @DataContract
export class ReportTemplateGetById implements IReturn<ReportTemplateGetByIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public templateId?: number;

    public constructor(init?: Partial<ReportTemplateGetById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportTemplateGetById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ReportTemplateGetByIdResponse(); }
}

// @DataContract
export class ReportTemplateGetFieldsByTemplateId implements IReturn<ReportTemplateGetFieldsByTemplateIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public templateId?: number;

    public constructor(init?: Partial<ReportTemplateGetFieldsByTemplateId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportTemplateGetFieldsByTemplateId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ReportTemplateGetFieldsByTemplateIdResponse(); }
}

// @DataContract
export class ReportTemplatePostSave implements IReturn<ReportTemplatePostSaveResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public template?: ReportTemplate;

    // @DataMember(Order=2)
    public fields?: ReportCustomTemplateField[];

    public constructor(init?: Partial<ReportTemplatePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportTemplatePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ReportTemplatePostSaveResponse(); }
}

// @DataContract
export class ReportPostSave implements IReturn<ReportPostSaveResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public report?: Report;

    // @DataMember(Order=2)
    public idReportFilters?: IdReportFilter[];

    // @DataMember(Order=3)
    public dateRangeReportFilters?: DateRangeReportFilter[];

    // @DataMember(Order=4)
    public recencyReportFilters?: RecencyReportFilter[];

    public constructor(init?: Partial<ReportPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ReportPostSaveResponse(); }
}

// @DataContract
export class ReportGetCollection implements IReturn<ReportGetCollectionResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<ReportGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ReportGetCollectionResponse(); }
}

// @DataContract
export class ReportGetPreviewById implements IReturn<ReportGetPreviewResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public reportId?: number;

    public constructor(init?: Partial<ReportGetPreviewById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportGetPreviewById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ReportGetPreviewResponse(); }
}

// @DataContract
export class ReportGetCustomPreviewById implements IReturn<ReportGetPreviewResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public reportId?: number;

    public constructor(init?: Partial<ReportGetCustomPreviewById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportGetCustomPreviewById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ReportGetPreviewResponse(); }
}

// @DataContract
export class ReportGetAssetsPreviewById implements IReturn<ReportGetPreviewResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public reportId?: number;

    public constructor(init?: Partial<ReportGetAssetsPreviewById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportGetAssetsPreviewById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ReportGetPreviewResponse(); }
}

// @DataContract
export class ReportGetSingleById implements IReturn<ReportGetSingleByIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public reportId?: number;

    public constructor(init?: Partial<ReportGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ReportGetSingleByIdResponse(); }
}

// @DataContract
export class ReportTemplateGetPreviewWithFilters implements IReturn<ReportTemplatePreviewResponse>, IPost
{
    [immerable] = true;

    // @DataMember(Order=1)
    public templateId?: number;

    // @DataMember(Order=2)
    public idReportFilters?: IdReportFilter[];

    // @DataMember(Order=3)
    public dateRangeReportFilters?: DateRangeReportFilter[];

    // @DataMember(Order=4)
    public recencyReportFilters?: RecencyReportFilter[];

    public constructor(init?: Partial<ReportTemplateGetPreviewWithFilters>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportTemplateGetPreviewWithFilters'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ReportTemplatePreviewResponse(); }
}

// @DataContract
export class ReportDeleteSingleById implements IReturn<DeleteSingleResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public reportId?: number;

    public constructor(init?: Partial<ReportDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteSingleResponse(); }
}

// @DataContract
export class ReportTemplateDeleteSingleById implements IReturn<DeleteSingleResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public templateId?: number;

    public constructor(init?: Partial<ReportTemplateDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportTemplateDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteSingleResponse(); }
}

// @DataContract
export class EmailOnlySalesSummaryGetDataByReportId implements IReturn<EmailOnlySalesSummaryGetDataByReportIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public reportId?: number;

    // @DataMember(Order=2)
    public startDate?: string;

    // @DataMember(Order=3)
    public endDate?: string;

    // @DataMember(Order=4)
    public numDaysPrior?: number;

    public constructor(init?: Partial<EmailOnlySalesSummaryGetDataByReportId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EmailOnlySalesSummaryGetDataByReportId'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EmailOnlySalesSummaryGetDataByReportIdResponse(); }
}

// @DataContract
export class EmailOnlyLotSummaryGetDataByReportId implements IReturn<EmailOnlyLotSummaryGetDataByReportIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public reportId?: number;

    public constructor(init?: Partial<EmailOnlyLotSummaryGetDataByReportId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EmailOnlyLotSummaryGetDataByReportId'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EmailOnlyLotSummaryGetDataByReportIdResponse(); }
}

// @DataContract
export class StagePlanGetSingleByStageIdSubStage implements IReturn<StagePlanGetSingleByStageIdSubStageResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    // @DataMember(Order=2)
    public subStage?: SubStages;

    public constructor(init?: Partial<StagePlanGetSingleByStageIdSubStage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePlanGetSingleByStageIdSubStage'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StagePlanGetSingleByStageIdSubStageResponse(); }
}

// @DataContract
export class StagePlanGetPointsByStageIdSubStage implements IReturn<StagePlanGetPointsByStageIdSubStageResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    // @DataMember(Order=2)
    public subStage?: SubStages;

    public constructor(init?: Partial<StagePlanGetPointsByStageIdSubStage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePlanGetPointsByStageIdSubStage'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StagePlanGetPointsByStageIdSubStageResponse(); }
}

// @DataContract
export class StagePlanPostSave implements IReturn<StagePlanPostSaveResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stagePlan?: StagePlan;

    public constructor(init?: Partial<StagePlanPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePlanPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StagePlanPostSaveResponse(); }
}

// @DataContract
export class StagePricelistGetByStageIdSubStage implements IReturn<StagePricelistGetByStageIdSubStageResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    // @DataMember(Order=2)
    public subStage?: SubStages;

    public constructor(init?: Partial<StagePricelistGetByStageIdSubStage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePricelistGetByStageIdSubStage'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StagePricelistGetByStageIdSubStageResponse(); }
}

// @DataContract
export class StagePricelistDownload implements IReturn<Blob>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    // @DataMember(Order=2)
    public subStage?: SubStages;

    public constructor(init?: Partial<StagePricelistDownload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePricelistDownload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @DataContract
export class PricelistGetSubstagesByStageId implements IReturn<PricelistGetSubstagesByStageIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    public constructor(init?: Partial<PricelistGetSubstagesByStageId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PricelistGetSubstagesByStageId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PricelistGetSubstagesByStageIdResponse(); }
}

// @DataContract
export class StageDeleteSingleById implements IReturn<DeleteSingleResponse>
{
    [immerable] = true;

    // @DataMember
    public stageId?: number;

    public constructor(init?: Partial<StageDeleteSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StageDeleteSingleById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteSingleResponse(); }
}

// @DataContract
export class StageGetCollectionByProjectId implements IReturn<StageGetCollectionByProjectIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    // @DataMember(Order=2)
    public skip?: number;

    // @DataMember(Order=3)
    public take?: number;

    public constructor(init?: Partial<StageGetCollectionByProjectId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StageGetCollectionByProjectId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StageGetCollectionByProjectIdResponse(); }
}

// @DataContract
export class StageGetCollectionByProjectIds implements IReturn<StageGetCollectionByProjectIdsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectIds?: number[];

    public constructor(init?: Partial<StageGetCollectionByProjectIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StageGetCollectionByProjectIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StageGetCollectionByProjectIdsResponse(); }
}

// @DataContract
export class StageGetSummaryCollectionByProjectId implements IReturn<StageGetSummaryCollectionByProjectIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    // @DataMember(Order=2)
    public showArchivedStages?: boolean;

    public constructor(init?: Partial<StageGetSummaryCollectionByProjectId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StageGetSummaryCollectionByProjectId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StageGetSummaryCollectionByProjectIdResponse(); }
}

// @DataContract
export class StageGetSummaryByProjectIdStageId implements IReturn<StageGetSummaryByProjectIdStageIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public projectId?: number;

    // @DataMember(Order=2)
    public stageId?: number;

    public constructor(init?: Partial<StageGetSummaryByProjectIdStageId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StageGetSummaryByProjectIdStageId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StageGetSummaryByProjectIdStageIdResponse(); }
}

// @DataContract
export class StageGetSubStagesByStageId implements IReturn<StageGetSubStagesByStageIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public stageId?: number;

    public constructor(init?: Partial<StageGetSubStagesByStageId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StageGetSubStagesByStageId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StageGetSubStagesByStageIdResponse(); }
}

// @DataContract
export class TenantGetAsCollection implements IReturn<TenantGetAsCollectionResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<TenantGetAsCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TenantGetAsCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TenantGetAsCollectionResponse(); }
}

// @DataContract
export class UserProjectSummaryGetCollection implements IReturn<UserProjectSummaryGetCollectionResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<UserProjectSummaryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserProjectSummaryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UserProjectSummaryGetCollectionResponse(); }
}

// @DataContract
export class ScriptedReportUpdateMailingLists implements IReturn<ScriptedReportUpdateMailingListsResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public reportId?: number;

    // @DataMember(Order=2)
    public toAddresses?: string;

    // @DataMember(Order=3)
    public ccAddresses?: string;

    public constructor(init?: Partial<ScriptedReportUpdateMailingLists>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScriptedReportUpdateMailingLists'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScriptedReportUpdateMailingListsResponse(); }
}

// @DataContract
export class UtilityEmailGetStringsByReportId implements IReturn<UtilityEmailGetStringsByReportIdResponse>
{
    [immerable] = true;

    // @DataMember(Order=1)
    public reportId?: number;

    public constructor(init?: Partial<UtilityEmailGetStringsByReportId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UtilityEmailGetStringsByReportId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UtilityEmailGetStringsByReportIdResponse(); }
}

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    [immerable] = true;

    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public userName: string;

    // @DataMember(Order=3)
    public password: string;

    // @DataMember(Order=4)
    public rememberMe?: boolean;

    // @DataMember(Order=5)
    public accessToken: string;

    // @DataMember(Order=6)
    public accessTokenSecret: string;

    // @DataMember(Order=7)
    public returnUrl: string;

    // @DataMember(Order=8)
    public errorView: string;

    // @DataMember(Order=9)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    [immerable] = true;

    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    [immerable] = true;

    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// @Route("/forms/file-upload", "POST")
export class PostUploadFile implements IReturn<UploadResponse>, IPost
{
    [immerable] = true;


    public constructor(init?: Partial<PostUploadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUploadFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/forms/file-upload/info/{Guid}", "GET")
export class GetUploadInfo implements IReturn<UploadResponse>, IGet
{
    [immerable] = true;

    public guid: string;

    public constructor(init?: Partial<GetUploadInfo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUploadInfo'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/forms/file-upload/{Guid}", "GET")
export class GetUpload implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public guid: string;

    public constructor(init?: Partial<GetUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/forms/file-upload/download/{Guid}", "GET")
export class DownloadUpload implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public guid: string;

    public constructor(init?: Partial<DownloadUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/forms/file-upload/{Guid}", "DELETE")
export class DeleteUpload implements IReturn<UploadResponse>, IDelete
{
    [immerable] = true;

    public guid: string;

    public constructor(init?: Partial<DeleteUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteUpload'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/forms/user/single/user", "GET")
// @Api(Description="User")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=500)
// @DataContract
export class UserGetSingle implements IReturn<UserSingleResponse>, IUserGetSingle
{
    [immerable] = true;

    /** @description The metadata of the request. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    public constructor(init?: Partial<UserGetSingle>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserGetSingle'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UserSingleResponse(); }
}

// @Route("/forms/lookup/collection/form-definition/{FormDefinitionId}", "GET")
// @Api(Description="Lookup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=500)
// @DataContract
export class LookupGetCollectionByFormDefinitionId implements IReturn<LookupCollectionResponse>, ILookupGetCollectionByFormDefinitionId
{
    [immerable] = true;

    /** @description The ID of the Form Definition associated with the lookup to retrieve. */
    // @DataMember(Order=1)
    public formDefinitionId?: number;

    public constructor(init?: Partial<LookupGetCollectionByFormDefinitionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupGetCollectionByFormDefinitionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LookupCollectionResponse(); }
}

// @Route("/forms/form-names", "GET")
export class GetFormMetadata implements IReturn<GetFormMetadataResponse>
{
    [immerable] = true;


    public constructor(init?: Partial<GetFormMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFormMetadataResponse(); }
}

// @Route("/forms/form-type/single/id/{Id}", "GET")
// @Api(Description="Form Type")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=500)
// @DataContract
export class FormTypeGetSingleById implements IReturn<FormTypeSingleResponse>, IConfigurationGetSingleById
{
    [immerable] = true;

    /** @description The ID of the form type to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FormTypeGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTypeGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormTypeSingleResponse(); }
}

// @Route("/forms/form-type/collection", "GET")
// @Api(Description="Form Type")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=500)
// @DataContract
export class FormTypeGetCollection implements IReturn<FormTypeCollectionResponse>, IConfigurationGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<FormTypeGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTypeGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormTypeCollectionResponse(); }
}

// @Route("/forms/form-type/single/code/{Code}", "GET")
// @Api(Description="Form Type")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=500)
// @DataContract
export class FormTypeGetSingleByCode implements IReturn<FormTypeSingleResponse>, IConfigurationGetSingleByCode
{
    [immerable] = true;

    /** @description The ID of the form type to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<FormTypeGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTypeGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormTypeSingleResponse(); }
}

// @Route("/forms/form-definition/single/id/{Id}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleById implements IReturn<FormDefinitionSingleResponse>, IConfigurationGetSingleById
{
    [immerable] = true;

    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FormDefinitionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/forms/form-definition/collection", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetCollection implements IReturn<FormDefinitionCollectionResponse>, IConfigurationGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<FormDefinitionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionCollectionResponse(); }
}

// @Route("/forms/form-definition/single/code/{Code}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleByCode implements IReturn<FormDefinitionSingleResponse>, IConfigurationGetSingleByCode
{
    [immerable] = true;

    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<FormDefinitionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/forms/form/agent/single/id/{Id}", "GET")
// @Api(Description="Form - Agent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=500)
// @DataContract
export class AgentGetSingleById implements IReturn<AgentSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the agent to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AgentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AgentSingleResponse(); }
}

// @Route("/forms/form/agent/collection", "GET")
// @Api(Description="Form - Agent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AgentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AgentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AgentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AgentCollectionResponse)", StatusCode=500)
// @DataContract
export class AgentGetCollection implements IReturn<AgentCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<AgentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AgentCollectionResponse(); }
}

// @Route("/forms/form/agent/create", "POST")
// @Api(Description="Form - Agent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=500)
// @DataContract
export class AgentPostCreate implements IReturn<AgentSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the agent. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the agent. */
    // @DataMember(Order=2)
    public data: Agent;

    public constructor(init?: Partial<AgentPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AgentSingleResponse(); }
}

// @Route("/forms/form/agent/save", "POST")
// @Api(Description="Form - Agent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AgentSingleResponse)", StatusCode=500)
// @DataContract
export class AgentPostSave implements IReturn<AgentSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the agent. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The agent to save. */
    // @DataMember(Order=2)
    public data: Agent;

    public constructor(init?: Partial<AgentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AgentSingleResponse(); }
}

// @Route("/forms/form/agent/validate", "POST")
// @Api(Description="Form - Agent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AgentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AgentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AgentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AgentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AgentValidationResponse)", StatusCode=500)
// @DataContract
export class AgentPostValidate implements IReturn<AgentValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the agent. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The agent to validate. */
    // @DataMember(Order=2)
    public data: Agent;

    public constructor(init?: Partial<AgentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AgentValidationResponse(); }
}

// @Route("/forms/form/agent-location/single/id/{Id}", "GET")
// @Api(Description="Form - AgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=500)
// @DataContract
export class AgentLocationGetSingleById implements IReturn<AgentLocationSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the agent location to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AgentLocationGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentLocationGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AgentLocationSingleResponse(); }
}

// @Route("/forms/form/agent-location/collection", "GET")
// @Api(Description="Form - AgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AgentLocationCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AgentLocationCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AgentLocationCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AgentLocationCollectionResponse)", StatusCode=500)
// @DataContract
export class AgentLocationGetCollection implements IReturn<AgentLocationCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<AgentLocationGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentLocationGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AgentLocationCollectionResponse(); }
}

// @Route("/forms/form/agent-location/create", "POST")
// @Api(Description="Form - AgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=500)
// @DataContract
export class AgentLocationPostCreate implements IReturn<AgentLocationSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the agent location. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the agent location. */
    // @DataMember(Order=2)
    public data: AgentLocation;

    public constructor(init?: Partial<AgentLocationPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentLocationPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AgentLocationSingleResponse(); }
}

// @Route("/forms/form/agent-location/save", "POST")
// @Api(Description="Form - AgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AgentLocationSingleResponse)", StatusCode=500)
// @DataContract
export class AgentLocationPostSave implements IReturn<AgentLocationSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the agent location. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The agent location to save. */
    // @DataMember(Order=2)
    public data: AgentLocation;

    public constructor(init?: Partial<AgentLocationPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentLocationPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AgentLocationSingleResponse(); }
}

// @Route("/forms/form/agent-location/validate", "POST")
// @Api(Description="Form - AgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AgentLocationValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AgentLocationValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AgentLocationValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AgentLocationValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AgentLocationValidationResponse)", StatusCode=500)
// @DataContract
export class AgentLocationPostValidate implements IReturn<AgentLocationValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the agent location. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The agent location to validate. */
    // @DataMember(Order=2)
    public data: AgentLocation;

    public constructor(init?: Partial<AgentLocationPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AgentLocationPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AgentLocationValidationResponse(); }
}

// @Route("/forms/form/asset/single/id/{Id}", "GET")
// @Api(Description="Form - Asset")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=500)
// @DataContract
export class AssetGetSingleById implements IReturn<AssetSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the asset to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AssetGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AssetSingleResponse(); }
}

// @Route("/forms/form/asset/collection", "GET")
// @Api(Description="Form - Asset")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetCollectionResponse)", StatusCode=500)
// @DataContract
export class AssetGetCollection implements IReturn<AssetCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<AssetGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AssetCollectionResponse(); }
}

// @Route("/forms/form/asset/create", "POST")
// @Api(Description="Form - Asset")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=500)
// @DataContract
export class AssetPostCreate implements IReturn<AssetSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the asset. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the asset. */
    // @DataMember(Order=2)
    public data: Asset;

    public constructor(init?: Partial<AssetPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssetSingleResponse(); }
}

// @Route("/forms/form/asset/save", "POST")
// @Api(Description="Form - Asset")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetSingleResponse)", StatusCode=500)
// @DataContract
export class AssetPostSave implements IReturn<AssetSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the asset. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The asset to save. */
    // @DataMember(Order=2)
    public data: Asset;

    public constructor(init?: Partial<AssetPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssetSingleResponse(); }
}

// @Route("/forms/form/asset/validate", "POST")
// @Api(Description="Form - Asset")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetValidationResponse)", StatusCode=500)
// @DataContract
export class AssetPostValidate implements IReturn<AssetValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the asset. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The asset to validate. */
    // @DataMember(Order=2)
    public data: Asset;

    public constructor(init?: Partial<AssetPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssetValidationResponse(); }
}

// @Route("/forms/form/asset-location/single/id/{Id}", "GET")
// @Api(Description="Form - AssetLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=500)
// @DataContract
export class AssetLocationGetSingleById implements IReturn<AssetLocationSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the asset location to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AssetLocationGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetLocationGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AssetLocationSingleResponse(); }
}

// @Route("/forms/form/asset-location/collection", "GET")
// @Api(Description="Form - AssetLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetLocationCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetLocationCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetLocationCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetLocationCollectionResponse)", StatusCode=500)
// @DataContract
export class AssetLocationGetCollection implements IReturn<AssetLocationCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<AssetLocationGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetLocationGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AssetLocationCollectionResponse(); }
}

// @Route("/forms/form/asset-location/create", "POST")
// @Api(Description="Form - AssetLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=500)
// @DataContract
export class AssetLocationPostCreate implements IReturn<AssetLocationSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the asset location. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the asset location. */
    // @DataMember(Order=2)
    public data: AssetLocation;

    public constructor(init?: Partial<AssetLocationPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetLocationPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssetLocationSingleResponse(); }
}

// @Route("/forms/form/asset-location/save", "POST")
// @Api(Description="Form - AssetLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetLocationSingleResponse)", StatusCode=500)
// @DataContract
export class AssetLocationPostSave implements IReturn<AssetLocationSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the asset location. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The asset location to save. */
    // @DataMember(Order=2)
    public data: AssetLocation;

    public constructor(init?: Partial<AssetLocationPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetLocationPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssetLocationSingleResponse(); }
}

// @Route("/forms/form/asset-location/validate", "POST")
// @Api(Description="Form - AssetLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetLocationValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetLocationValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetLocationValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetLocationValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetLocationValidationResponse)", StatusCode=500)
// @DataContract
export class AssetLocationPostValidate implements IReturn<AssetLocationValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the asset location. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The asset location to validate. */
    // @DataMember(Order=2)
    public data: AssetLocation;

    public constructor(init?: Partial<AssetLocationPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetLocationPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssetLocationValidationResponse(); }
}

// @Route("/forms/form/asset-tenancy/single/id/{Id}", "GET")
// @Api(Description="Form - AssetTenancy")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=500)
// @DataContract
export class AssetTenancyGetSingleById implements IReturn<AssetTenancySingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the asset tenancy to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AssetTenancyGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetTenancyGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AssetTenancySingleResponse(); }
}

// @Route("/forms/form/asset-tenancy/collection", "GET")
// @Api(Description="Form - AssetTenancy")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetTenancyCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetTenancyCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetTenancyCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetTenancyCollectionResponse)", StatusCode=500)
// @DataContract
export class AssetTenancyGetCollection implements IReturn<AssetTenancyCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<AssetTenancyGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetTenancyGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AssetTenancyCollectionResponse(); }
}

// @Route("/forms/form/asset-tenancy/create", "POST")
// @Api(Description="Form - AssetTenancy")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=500)
// @DataContract
export class AssetTenancyPostCreate implements IReturn<AssetTenancySingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the asset tenancy. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the asset tenancy. */
    // @DataMember(Order=2)
    public data: AssetTenancy;

    public constructor(init?: Partial<AssetTenancyPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetTenancyPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssetTenancySingleResponse(); }
}

// @Route("/forms/form/asset-tenancy/save", "POST")
// @Api(Description="Form - AssetTenancy")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetTenancySingleResponse)", StatusCode=500)
// @DataContract
export class AssetTenancyPostSave implements IReturn<AssetTenancySingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the asset tenancy. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The asset tenancy to save. */
    // @DataMember(Order=2)
    public data: AssetTenancy;

    public constructor(init?: Partial<AssetTenancyPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetTenancyPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssetTenancySingleResponse(); }
}

// @Route("/forms/form/asset-tenancy/validate", "POST")
// @Api(Description="Form - AssetTenancy")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetTenancyValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetTenancyValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetTenancyValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetTenancyValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetTenancyValidationResponse)", StatusCode=500)
// @DataContract
export class AssetTenancyPostValidate implements IReturn<AssetTenancyValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the asset tenancy. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The asset tenancy to validate. */
    // @DataMember(Order=2)
    public data: AssetTenancy;

    public constructor(init?: Partial<AssetTenancyPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetTenancyPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssetTenancyValidationResponse(); }
}

// @Route("/forms/form/asset-value/single/id/{Id}", "GET")
// @Api(Description="Form - AssetValue")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=500)
// @DataContract
export class AssetValueGetSingleById implements IReturn<AssetValueSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the asset value to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AssetValueGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetValueGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AssetValueSingleResponse(); }
}

// @Route("/forms/form/asset-value/collection", "GET")
// @Api(Description="Form - AssetValue")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetValueCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetValueCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetValueCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetValueCollectionResponse)", StatusCode=500)
// @DataContract
export class AssetValueGetCollection implements IReturn<AssetValueCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<AssetValueGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetValueGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AssetValueCollectionResponse(); }
}

// @Route("/forms/form/asset-value/create", "POST")
// @Api(Description="Form - AssetValue")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=500)
// @DataContract
export class AssetValuePostCreate implements IReturn<AssetValueSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the asset value. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the asset value. */
    // @DataMember(Order=2)
    public data: AssetValue;

    public constructor(init?: Partial<AssetValuePostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetValuePostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssetValueSingleResponse(); }
}

// @Route("/forms/form/asset-value/save", "POST")
// @Api(Description="Form - AssetValue")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetValueSingleResponse)", StatusCode=500)
// @DataContract
export class AssetValuePostSave implements IReturn<AssetValueSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the asset value. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The asset value to save. */
    // @DataMember(Order=2)
    public data: AssetValue;

    public constructor(init?: Partial<AssetValuePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetValuePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssetValueSingleResponse(); }
}

// @Route("/forms/form/asset-value/validate", "POST")
// @Api(Description="Form - AssetValue")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AssetValueValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AssetValueValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AssetValueValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AssetValueValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AssetValueValidationResponse)", StatusCode=500)
// @DataContract
export class AssetValuePostValidate implements IReturn<AssetValueValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the asset value. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The asset value to validate. */
    // @DataMember(Order=2)
    public data: AssetValue;

    public constructor(init?: Partial<AssetValuePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssetValuePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssetValueValidationResponse(); }
}

// @Route("/forms/form/attachment/single/id/{Id}", "GET")
// @Api(Description="Form - Attachment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=500)
// @DataContract
export class AttachmentGetSingleById implements IReturn<AttachmentSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the attachment to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AttachmentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AttachmentSingleResponse(); }
}

// @Route("/forms/form/attachment/collection", "GET")
// @Api(Description="Form - Attachment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AttachmentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AttachmentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AttachmentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AttachmentCollectionResponse)", StatusCode=500)
// @DataContract
export class AttachmentGetCollection implements IReturn<AttachmentCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<AttachmentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AttachmentCollectionResponse(); }
}

// @Route("/forms/form/attachment/create", "POST")
// @Api(Description="Form - Attachment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=500)
// @DataContract
export class AttachmentPostCreate implements IReturn<AttachmentSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the attachment. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the attachment. */
    // @DataMember(Order=2)
    public data: Attachment;

    public constructor(init?: Partial<AttachmentPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AttachmentSingleResponse(); }
}

// @Route("/forms/form/attachment/save", "POST")
// @Api(Description="Form - Attachment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AttachmentSingleResponse)", StatusCode=500)
// @DataContract
export class AttachmentPostSave implements IReturn<AttachmentSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the attachment. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The attachment to save. */
    // @DataMember(Order=2)
    public data: Attachment;

    public constructor(init?: Partial<AttachmentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AttachmentSingleResponse(); }
}

// @Route("/forms/form/attachment/validate", "POST")
// @Api(Description="Form - Attachment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AttachmentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AttachmentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AttachmentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AttachmentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AttachmentValidationResponse)", StatusCode=500)
// @DataContract
export class AttachmentPostValidate implements IReturn<AttachmentValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the attachment. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The attachment to validate. */
    // @DataMember(Order=2)
    public data: Attachment;

    public constructor(init?: Partial<AttachmentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AttachmentValidationResponse(); }
}

// @Route("/forms/form/attachment-type/single/id/{Id}", "GET")
// @Api(Description="Form - AttachmentType")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=500)
// @DataContract
export class AttachmentTypeGetSingleById implements IReturn<AttachmentTypeSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the attachment type to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AttachmentTypeGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentTypeGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AttachmentTypeSingleResponse(); }
}

// @Route("/forms/form/attachment-type/collection", "GET")
// @Api(Description="Form - AttachmentType")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AttachmentTypeCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AttachmentTypeCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AttachmentTypeCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AttachmentTypeCollectionResponse)", StatusCode=500)
// @DataContract
export class AttachmentTypeGetCollection implements IReturn<AttachmentTypeCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<AttachmentTypeGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentTypeGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AttachmentTypeCollectionResponse(); }
}

// @Route("/forms/form/attachment-type/create", "POST")
// @Api(Description="Form - AttachmentType")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=500)
// @DataContract
export class AttachmentTypePostCreate implements IReturn<AttachmentTypeSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the attachment type. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the attachment type. */
    // @DataMember(Order=2)
    public data: AttachmentType;

    public constructor(init?: Partial<AttachmentTypePostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentTypePostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AttachmentTypeSingleResponse(); }
}

// @Route("/forms/form/attachment-type/save", "POST")
// @Api(Description="Form - AttachmentType")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AttachmentTypeSingleResponse)", StatusCode=500)
// @DataContract
export class AttachmentTypePostSave implements IReturn<AttachmentTypeSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the attachment type. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The attachment type to save. */
    // @DataMember(Order=2)
    public data: AttachmentType;

    public constructor(init?: Partial<AttachmentTypePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentTypePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AttachmentTypeSingleResponse(); }
}

// @Route("/forms/form/attachment-type/validate", "POST")
// @Api(Description="Form - AttachmentType")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.AttachmentTypeValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.AttachmentTypeValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.AttachmentTypeValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.AttachmentTypeValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.AttachmentTypeValidationResponse)", StatusCode=500)
// @DataContract
export class AttachmentTypePostValidate implements IReturn<AttachmentTypeValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the attachment type. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The attachment type to validate. */
    // @DataMember(Order=2)
    public data: AttachmentType;

    public constructor(init?: Partial<AttachmentTypePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentTypePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AttachmentTypeValidationResponse(); }
}

// @Route("/forms/form/contract/single/id/{Id}", "GET")
// @Api(Description="Form - Contract")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=500)
// @DataContract
export class ContractGetSingleById implements IReturn<ContractSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the contract to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ContractGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContractGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ContractSingleResponse(); }
}

// @Route("/forms/form/contract/collection", "GET")
// @Api(Description="Form - Contract")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ContractCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ContractCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ContractCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ContractCollectionResponse)", StatusCode=500)
// @DataContract
export class ContractGetCollection implements IReturn<ContractCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<ContractGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContractGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ContractCollectionResponse(); }
}

// @Route("/forms/form/contract/create", "POST")
// @Api(Description="Form - Contract")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=500)
// @DataContract
export class ContractPostCreate implements IReturn<ContractSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the contract. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the contract. */
    // @DataMember(Order=2)
    public data: Contract;

    public constructor(init?: Partial<ContractPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContractPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ContractSingleResponse(); }
}

// @Route("/forms/form/contract/save", "POST")
// @Api(Description="Form - Contract")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ContractSingleResponse)", StatusCode=500)
// @DataContract
export class ContractPostSave implements IReturn<ContractSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the contract. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The contract to save. */
    // @DataMember(Order=2)
    public data: Contract;

    public constructor(init?: Partial<ContractPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContractPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ContractSingleResponse(); }
}

// @Route("/forms/form/contract/validate", "POST")
// @Api(Description="Form - Contract")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ContractValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ContractValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ContractValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ContractValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ContractValidationResponse)", StatusCode=500)
// @DataContract
export class ContractPostValidate implements IReturn<ContractValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the contract. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The contract to validate. */
    // @DataMember(Order=2)
    public data: Contract;

    public constructor(init?: Partial<ContractPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContractPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ContractValidationResponse(); }
}

// @Route("/forms/form/cost-to-complete/single/id/{Id}", "GET")
// @Api(Description="Form - CostToComplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=500)
// @DataContract
export class CostToCompleteGetSingleById implements IReturn<CostToCompleteSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the cost to complete to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CostToCompleteGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CostToCompleteGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CostToCompleteSingleResponse(); }
}

// @Route("/forms/form/cost-to-complete/collection", "GET")
// @Api(Description="Form - CostToComplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.CostToCompleteCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.CostToCompleteCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.CostToCompleteCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.CostToCompleteCollectionResponse)", StatusCode=500)
// @DataContract
export class CostToCompleteGetCollection implements IReturn<CostToCompleteCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<CostToCompleteGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CostToCompleteGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CostToCompleteCollectionResponse(); }
}

// @Route("/forms/form/cost-to-complete/create", "POST")
// @Api(Description="Form - CostToComplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=500)
// @DataContract
export class CostToCompletePostCreate implements IReturn<CostToCompleteSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the cost to complete. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the cost to complete. */
    // @DataMember(Order=2)
    public data: CostToComplete;

    public constructor(init?: Partial<CostToCompletePostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CostToCompletePostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CostToCompleteSingleResponse(); }
}

// @Route("/forms/form/cost-to-complete/save", "POST")
// @Api(Description="Form - CostToComplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.CostToCompleteSingleResponse)", StatusCode=500)
// @DataContract
export class CostToCompletePostSave implements IReturn<CostToCompleteSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the cost to complete. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The cost to complete to save. */
    // @DataMember(Order=2)
    public data: CostToComplete;

    public constructor(init?: Partial<CostToCompletePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CostToCompletePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CostToCompleteSingleResponse(); }
}

// @Route("/forms/form/cost-to-complete/validate", "POST")
// @Api(Description="Form - CostToComplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.CostToCompleteValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.CostToCompleteValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.CostToCompleteValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.CostToCompleteValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.CostToCompleteValidationResponse)", StatusCode=500)
// @DataContract
export class CostToCompletePostValidate implements IReturn<CostToCompleteValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the cost to complete. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The cost to complete to validate. */
    // @DataMember(Order=2)
    public data: CostToComplete;

    public constructor(init?: Partial<CostToCompletePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CostToCompletePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CostToCompleteValidationResponse(); }
}

// @Route("/forms/form/export-template/single/id/{Id}", "GET")
// @Api(Description="Form - ExportTemplate")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=500)
// @DataContract
export class ExportTemplateGetSingleById implements IReturn<ExportTemplateSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the export template to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ExportTemplateGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportTemplateGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ExportTemplateSingleResponse(); }
}

// @Route("/forms/form/export-template/collection", "GET")
// @Api(Description="Form - ExportTemplate")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ExportTemplateCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ExportTemplateCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ExportTemplateCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ExportTemplateCollectionResponse)", StatusCode=500)
// @DataContract
export class ExportTemplateGetCollection implements IReturn<ExportTemplateCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<ExportTemplateGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportTemplateGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ExportTemplateCollectionResponse(); }
}

// @Route("/forms/form/export-template/create", "POST")
// @Api(Description="Form - ExportTemplate")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=500)
// @DataContract
export class ExportTemplatePostCreate implements IReturn<ExportTemplateSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the export template. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the export template. */
    // @DataMember(Order=2)
    public data: ExportTemplate;

    public constructor(init?: Partial<ExportTemplatePostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportTemplatePostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExportTemplateSingleResponse(); }
}

// @Route("/forms/form/export-template/save", "POST")
// @Api(Description="Form - ExportTemplate")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ExportTemplateSingleResponse)", StatusCode=500)
// @DataContract
export class ExportTemplatePostSave implements IReturn<ExportTemplateSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the export template. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The export template to save. */
    // @DataMember(Order=2)
    public data: ExportTemplate;

    public constructor(init?: Partial<ExportTemplatePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportTemplatePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExportTemplateSingleResponse(); }
}

// @Route("/forms/form/export-template/validate", "POST")
// @Api(Description="Form - ExportTemplate")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ExportTemplateValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ExportTemplateValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ExportTemplateValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ExportTemplateValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ExportTemplateValidationResponse)", StatusCode=500)
// @DataContract
export class ExportTemplatePostValidate implements IReturn<ExportTemplateValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the export template. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The export template to validate. */
    // @DataMember(Order=2)
    public data: ExportTemplate;

    public constructor(init?: Partial<ExportTemplatePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportTemplatePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExportTemplateValidationResponse(); }
}

// @Route("/forms/form/lot/single/id/{Id}", "GET")
// @Api(Description="Form - Lot")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=500)
// @DataContract
export class LotGetSingleById implements IReturn<LotSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the lot to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<LotGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotSingleResponse(); }
}

// @Route("/forms/form/lot/collection", "GET")
// @Api(Description="Form - Lot")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotCollectionResponse)", StatusCode=500)
// @DataContract
export class LotGetCollection implements IReturn<LotCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<LotGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotCollectionResponse(); }
}

// @Route("/forms/form/lot/create", "POST")
// @Api(Description="Form - Lot")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=500)
// @DataContract
export class LotPostCreate implements IReturn<LotSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the lot. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the lot. */
    // @DataMember(Order=2)
    public data: Lot;

    public constructor(init?: Partial<LotPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LotSingleResponse(); }
}

// @Route("/forms/form/lot/save", "POST")
// @Api(Description="Form - Lot")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotSingleResponse)", StatusCode=500)
// @DataContract
export class LotPostSave implements IReturn<LotSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the lot. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The lot to save. */
    // @DataMember(Order=2)
    public data: Lot;

    public constructor(init?: Partial<LotPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LotSingleResponse(); }
}

// @Route("/forms/form/lot/validate", "POST")
// @Api(Description="Form - Lot")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.LotValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotValidationResponse)", StatusCode=500)
// @DataContract
export class LotPostValidate implements IReturn<LotValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the lot. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The lot to validate. */
    // @DataMember(Order=2)
    public data: Lot;

    public constructor(init?: Partial<LotPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LotValidationResponse(); }
}

// @Route("/forms/form/lot-note/single/id/{Id}", "GET")
// @Api(Description="Form - LotNote")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=500)
// @DataContract
export class LotNoteGetSingleById implements IReturn<LotNoteSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the lot note to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<LotNoteGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotNoteGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotNoteSingleResponse(); }
}

// @Route("/forms/form/lot-note/collection", "GET")
// @Api(Description="Form - LotNote")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotNoteCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotNoteCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotNoteCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotNoteCollectionResponse)", StatusCode=500)
// @DataContract
export class LotNoteGetCollection implements IReturn<LotNoteCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<LotNoteGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotNoteGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotNoteCollectionResponse(); }
}

// @Route("/forms/form/lot-note/create", "POST")
// @Api(Description="Form - LotNote")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=500)
// @DataContract
export class LotNotePostCreate implements IReturn<LotNoteSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the lot note. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the lot note. */
    // @DataMember(Order=2)
    public data: LotNote;

    public constructor(init?: Partial<LotNotePostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotNotePostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LotNoteSingleResponse(); }
}

// @Route("/forms/form/lot-note/save", "POST")
// @Api(Description="Form - LotNote")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotNoteSingleResponse)", StatusCode=500)
// @DataContract
export class LotNotePostSave implements IReturn<LotNoteSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the lot note. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The lot note to save. */
    // @DataMember(Order=2)
    public data: LotNote;

    public constructor(init?: Partial<LotNotePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotNotePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LotNoteSingleResponse(); }
}

// @Route("/forms/form/lot-note/validate", "POST")
// @Api(Description="Form - LotNote")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotNoteValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotNoteValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.LotNoteValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotNoteValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotNoteValidationResponse)", StatusCode=500)
// @DataContract
export class LotNotePostValidate implements IReturn<LotNoteValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the lot note. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The lot note to validate. */
    // @DataMember(Order=2)
    public data: LotNote;

    public constructor(init?: Partial<LotNotePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotNotePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LotNoteValidationResponse(); }
}

// @Route("/forms/form/lot-property/single/id/{Id}", "GET")
// @Api(Description="Form - LotProperty")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=500)
// @DataContract
export class LotPropertyGetSingleById implements IReturn<LotPropertySingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the lot property to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<LotPropertyGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotPropertyGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotPropertySingleResponse(); }
}

// @Route("/forms/form/lot-property/collection", "GET")
// @Api(Description="Form - LotProperty")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotPropertyCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotPropertyCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotPropertyCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotPropertyCollectionResponse)", StatusCode=500)
// @DataContract
export class LotPropertyGetCollection implements IReturn<LotPropertyCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<LotPropertyGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotPropertyGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LotPropertyCollectionResponse(); }
}

// @Route("/forms/form/lot-property/create", "POST")
// @Api(Description="Form - LotProperty")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=500)
// @DataContract
export class LotPropertyPostCreate implements IReturn<LotPropertySingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the lot property. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the lot property. */
    // @DataMember(Order=2)
    public data: LotProperty;

    public constructor(init?: Partial<LotPropertyPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotPropertyPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LotPropertySingleResponse(); }
}

// @Route("/forms/form/lot-property/save", "POST")
// @Api(Description="Form - LotProperty")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotPropertySingleResponse)", StatusCode=500)
// @DataContract
export class LotPropertyPostSave implements IReturn<LotPropertySingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the lot property. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The lot property to save. */
    // @DataMember(Order=2)
    public data: LotProperty;

    public constructor(init?: Partial<LotPropertyPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotPropertyPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LotPropertySingleResponse(); }
}

// @Route("/forms/form/lot-property/validate", "POST")
// @Api(Description="Form - LotProperty")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.LotPropertyValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.LotPropertyValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.LotPropertyValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.LotPropertyValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.LotPropertyValidationResponse)", StatusCode=500)
// @DataContract
export class LotPropertyPostValidate implements IReturn<LotPropertyValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the lot property. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The lot property to validate. */
    // @DataMember(Order=2)
    public data: LotProperty;

    public constructor(init?: Partial<LotPropertyPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LotPropertyPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LotPropertyValidationResponse(); }
}

// @Route("/forms/form/precinct/single/id/{Id}", "GET")
// @Api(Description="Form - Precinct")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=500)
// @DataContract
export class PrecinctGetSingleById implements IReturn<PrecinctSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the precinct to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PrecinctGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrecinctGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PrecinctSingleResponse(); }
}

// @Route("/forms/form/precinct/collection", "GET")
// @Api(Description="Form - Precinct")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PrecinctCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PrecinctCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PrecinctCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PrecinctCollectionResponse)", StatusCode=500)
// @DataContract
export class PrecinctGetCollection implements IReturn<PrecinctCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<PrecinctGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrecinctGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PrecinctCollectionResponse(); }
}

// @Route("/forms/form/precinct/create", "POST")
// @Api(Description="Form - Precinct")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=500)
// @DataContract
export class PrecinctPostCreate implements IReturn<PrecinctSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the precinct. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the precinct. */
    // @DataMember(Order=2)
    public data: Precinct;

    public constructor(init?: Partial<PrecinctPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrecinctPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PrecinctSingleResponse(); }
}

// @Route("/forms/form/precinct/save", "POST")
// @Api(Description="Form - Precinct")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PrecinctSingleResponse)", StatusCode=500)
// @DataContract
export class PrecinctPostSave implements IReturn<PrecinctSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the precinct. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The precinct to save. */
    // @DataMember(Order=2)
    public data: Precinct;

    public constructor(init?: Partial<PrecinctPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrecinctPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PrecinctSingleResponse(); }
}

// @Route("/forms/form/precinct/validate", "POST")
// @Api(Description="Form - Precinct")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PrecinctValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PrecinctValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PrecinctValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PrecinctValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PrecinctValidationResponse)", StatusCode=500)
// @DataContract
export class PrecinctPostValidate implements IReturn<PrecinctValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the precinct. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The precinct to validate. */
    // @DataMember(Order=2)
    public data: Precinct;

    public constructor(init?: Partial<PrecinctPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrecinctPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PrecinctValidationResponse(); }
}

// @Route("/forms/form/project/single/id/{Id}", "GET")
// @Api(Description="Form - Project")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectGetSingleById implements IReturn<ProjectSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the project to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ProjectGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectSingleResponse(); }
}

// @Route("/forms/form/project/collection", "GET")
// @Api(Description="Form - Project")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectCollectionResponse)", StatusCode=500)
// @DataContract
export class ProjectGetCollection implements IReturn<ProjectCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<ProjectGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectCollectionResponse(); }
}

// @Route("/forms/form/project/create", "POST")
// @Api(Description="Form - Project")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectPostCreate implements IReturn<ProjectSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the project. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the project. */
    // @DataMember(Order=2)
    public data: Project;

    public constructor(init?: Partial<ProjectPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectSingleResponse(); }
}

// @Route("/forms/form/project/save", "POST")
// @Api(Description="Form - Project")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectPostSave implements IReturn<ProjectSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the project. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The project to save. */
    // @DataMember(Order=2)
    public data: Project;

    public constructor(init?: Partial<ProjectPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectSingleResponse(); }
}

// @Route("/forms/form/project/validate", "POST")
// @Api(Description="Form - Project")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectValidationResponse)", StatusCode=500)
// @DataContract
export class ProjectPostValidate implements IReturn<ProjectValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the project. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The project to validate. */
    // @DataMember(Order=2)
    public data: Project;

    public constructor(init?: Partial<ProjectPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectValidationResponse(); }
}

// @Route("/forms/form/project-agent-location/single/id/{Id}", "GET")
// @Api(Description="Form - ProjectAgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectAgentLocationGetSingleById implements IReturn<ProjectAgentLocationSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the project agent location to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ProjectAgentLocationGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectAgentLocationGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectAgentLocationSingleResponse(); }
}

// @Route("/forms/form/project-agent-location/collection", "GET")
// @Api(Description="Form - ProjectAgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationCollectionResponse)", StatusCode=500)
// @DataContract
export class ProjectAgentLocationGetCollection implements IReturn<ProjectAgentLocationCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<ProjectAgentLocationGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectAgentLocationGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectAgentLocationCollectionResponse(); }
}

// @Route("/forms/form/project-agent-location/create", "POST")
// @Api(Description="Form - ProjectAgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectAgentLocationPostCreate implements IReturn<ProjectAgentLocationSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the project agent location. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the project agent location. */
    // @DataMember(Order=2)
    public data: ProjectAgentLocation;

    public constructor(init?: Partial<ProjectAgentLocationPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectAgentLocationPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectAgentLocationSingleResponse(); }
}

// @Route("/forms/form/project-agent-location/save", "POST")
// @Api(Description="Form - ProjectAgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectAgentLocationPostSave implements IReturn<ProjectAgentLocationSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the project agent location. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The project agent location to save. */
    // @DataMember(Order=2)
    public data: ProjectAgentLocation;

    public constructor(init?: Partial<ProjectAgentLocationPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectAgentLocationPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectAgentLocationSingleResponse(); }
}

// @Route("/forms/form/project-agent-location/validate", "POST")
// @Api(Description="Form - ProjectAgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectAgentLocationValidationResponse)", StatusCode=500)
// @DataContract
export class ProjectAgentLocationPostValidate implements IReturn<ProjectAgentLocationValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the project agent location. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The project agent location to validate. */
    // @DataMember(Order=2)
    public data: ProjectAgentLocation;

    public constructor(init?: Partial<ProjectAgentLocationPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectAgentLocationPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectAgentLocationValidationResponse(); }
}

// @Route("/forms/form/project-commission/single/id/{Id}", "GET")
// @Api(Description="Form - ProjectCommission")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectCommissionGetSingleById implements IReturn<ProjectCommissionSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the project commission to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ProjectCommissionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectCommissionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectCommissionSingleResponse(); }
}

// @Route("/forms/form/project-commission/collection", "GET")
// @Api(Description="Form - ProjectCommission")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectCommissionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectCommissionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectCommissionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectCommissionCollectionResponse)", StatusCode=500)
// @DataContract
export class ProjectCommissionGetCollection implements IReturn<ProjectCommissionCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<ProjectCommissionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectCommissionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectCommissionCollectionResponse(); }
}

// @Route("/forms/form/project-commission/create", "POST")
// @Api(Description="Form - ProjectCommission")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectCommissionPostCreate implements IReturn<ProjectCommissionSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the project commission. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the project commission. */
    // @DataMember(Order=2)
    public data: ProjectCommission;

    public constructor(init?: Partial<ProjectCommissionPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectCommissionPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectCommissionSingleResponse(); }
}

// @Route("/forms/form/project-commission/save", "POST")
// @Api(Description="Form - ProjectCommission")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectCommissionSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectCommissionPostSave implements IReturn<ProjectCommissionSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the project commission. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The project commission to save. */
    // @DataMember(Order=2)
    public data: ProjectCommission;

    public constructor(init?: Partial<ProjectCommissionPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectCommissionPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectCommissionSingleResponse(); }
}

// @Route("/forms/form/project-commission/validate", "POST")
// @Api(Description="Form - ProjectCommission")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectCommissionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectCommissionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectCommissionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectCommissionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectCommissionValidationResponse)", StatusCode=500)
// @DataContract
export class ProjectCommissionPostValidate implements IReturn<ProjectCommissionValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the project commission. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The project commission to validate. */
    // @DataMember(Order=2)
    public data: ProjectCommission;

    public constructor(init?: Partial<ProjectCommissionPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectCommissionPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectCommissionValidationResponse(); }
}

// @Route("/forms/form/project-precinct/single/id/{Id}", "GET")
// @Api(Description="Form - ProjectPrecinct")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectPrecinctGetSingleById implements IReturn<ProjectPrecinctSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the project precinct to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ProjectPrecinctGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPrecinctGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectPrecinctSingleResponse(); }
}

// @Route("/forms/form/project-precinct/collection", "GET")
// @Api(Description="Form - ProjectPrecinct")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectPrecinctCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectPrecinctCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectPrecinctCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectPrecinctCollectionResponse)", StatusCode=500)
// @DataContract
export class ProjectPrecinctGetCollection implements IReturn<ProjectPrecinctCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<ProjectPrecinctGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPrecinctGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectPrecinctCollectionResponse(); }
}

// @Route("/forms/form/project-precinct/create", "POST")
// @Api(Description="Form - ProjectPrecinct")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectPrecinctPostCreate implements IReturn<ProjectPrecinctSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the project precinct. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the project precinct. */
    // @DataMember(Order=2)
    public data: ProjectPrecinct;

    public constructor(init?: Partial<ProjectPrecinctPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPrecinctPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectPrecinctSingleResponse(); }
}

// @Route("/forms/form/project-precinct/save", "POST")
// @Api(Description="Form - ProjectPrecinct")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectPrecinctSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectPrecinctPostSave implements IReturn<ProjectPrecinctSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the project precinct. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The project precinct to save. */
    // @DataMember(Order=2)
    public data: ProjectPrecinct;

    public constructor(init?: Partial<ProjectPrecinctPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPrecinctPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectPrecinctSingleResponse(); }
}

// @Route("/forms/form/project-precinct/validate", "POST")
// @Api(Description="Form - ProjectPrecinct")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectPrecinctValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectPrecinctValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectPrecinctValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectPrecinctValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectPrecinctValidationResponse)", StatusCode=500)
// @DataContract
export class ProjectPrecinctPostValidate implements IReturn<ProjectPrecinctValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the project precinct. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The project precinct to validate. */
    // @DataMember(Order=2)
    public data: ProjectPrecinct;

    public constructor(init?: Partial<ProjectPrecinctPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPrecinctPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectPrecinctValidationResponse(); }
}

// @Route("/forms/form/project-property-default/single/id/{Id}", "GET")
// @Api(Description="Form - ProjectPropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectPropertyDefaultGetSingleById implements IReturn<ProjectPropertyDefaultSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the project property default to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ProjectPropertyDefaultGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPropertyDefaultGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectPropertyDefaultSingleResponse(); }
}

// @Route("/forms/form/project-property-default/collection", "GET")
// @Api(Description="Form - ProjectPropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultCollectionResponse)", StatusCode=500)
// @DataContract
export class ProjectPropertyDefaultGetCollection implements IReturn<ProjectPropertyDefaultCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<ProjectPropertyDefaultGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPropertyDefaultGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProjectPropertyDefaultCollectionResponse(); }
}

// @Route("/forms/form/project-property-default/create", "POST")
// @Api(Description="Form - ProjectPropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectPropertyDefaultPostCreate implements IReturn<ProjectPropertyDefaultSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the project property default. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the project property default. */
    // @DataMember(Order=2)
    public data: ProjectPropertyDefault;

    public constructor(init?: Partial<ProjectPropertyDefaultPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPropertyDefaultPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectPropertyDefaultSingleResponse(); }
}

// @Route("/forms/form/project-property-default/save", "POST")
// @Api(Description="Form - ProjectPropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultSingleResponse)", StatusCode=500)
// @DataContract
export class ProjectPropertyDefaultPostSave implements IReturn<ProjectPropertyDefaultSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the project property default. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The project property default to save. */
    // @DataMember(Order=2)
    public data: ProjectPropertyDefault;

    public constructor(init?: Partial<ProjectPropertyDefaultPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPropertyDefaultPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectPropertyDefaultSingleResponse(); }
}

// @Route("/forms/form/project-property-default/validate", "POST")
// @Api(Description="Form - ProjectPropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.ProjectPropertyDefaultValidationResponse)", StatusCode=500)
// @DataContract
export class ProjectPropertyDefaultPostValidate implements IReturn<ProjectPropertyDefaultValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the project property default. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The project property default to validate. */
    // @DataMember(Order=2)
    public data: ProjectPropertyDefault;

    public constructor(init?: Partial<ProjectPropertyDefaultPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProjectPropertyDefaultPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProjectPropertyDefaultValidationResponse(); }
}

// @Route("/forms/form/property/single/id/{Id}", "GET")
// @Api(Description="Form - Property")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=500)
// @DataContract
export class PropertyGetSingleById implements IReturn<PropertySingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the property to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PropertyGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PropertyGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PropertySingleResponse(); }
}

// @Route("/forms/form/property/collection", "GET")
// @Api(Description="Form - Property")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PropertyCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PropertyCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PropertyCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PropertyCollectionResponse)", StatusCode=500)
// @DataContract
export class PropertyGetCollection implements IReturn<PropertyCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<PropertyGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PropertyGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PropertyCollectionResponse(); }
}

// @Route("/forms/form/property/create", "POST")
// @Api(Description="Form - Property")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=500)
// @DataContract
export class PropertyPostCreate implements IReturn<PropertySingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the property. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the property. */
    // @DataMember(Order=2)
    public data: Property;

    public constructor(init?: Partial<PropertyPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PropertyPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PropertySingleResponse(); }
}

// @Route("/forms/form/property/save", "POST")
// @Api(Description="Form - Property")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PropertySingleResponse)", StatusCode=500)
// @DataContract
export class PropertyPostSave implements IReturn<PropertySingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the property. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The property to save. */
    // @DataMember(Order=2)
    public data: Property;

    public constructor(init?: Partial<PropertyPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PropertyPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PropertySingleResponse(); }
}

// @Route("/forms/form/property/validate", "POST")
// @Api(Description="Form - Property")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PropertyValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PropertyValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PropertyValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PropertyValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PropertyValidationResponse)", StatusCode=500)
// @DataContract
export class PropertyPostValidate implements IReturn<PropertyValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the property. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The property to validate. */
    // @DataMember(Order=2)
    public data: Property;

    public constructor(init?: Partial<PropertyPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PropertyPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PropertyValidationResponse(); }
}

// @Route("/forms/form/property-default/single/id/{Id}", "GET")
// @Api(Description="Form - PropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=500)
// @DataContract
export class PropertyDefaultGetSingleById implements IReturn<PropertyDefaultSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the property default to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PropertyDefaultGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PropertyDefaultGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PropertyDefaultSingleResponse(); }
}

// @Route("/forms/form/property-default/collection", "GET")
// @Api(Description="Form - PropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PropertyDefaultCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PropertyDefaultCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PropertyDefaultCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PropertyDefaultCollectionResponse)", StatusCode=500)
// @DataContract
export class PropertyDefaultGetCollection implements IReturn<PropertyDefaultCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<PropertyDefaultGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PropertyDefaultGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PropertyDefaultCollectionResponse(); }
}

// @Route("/forms/form/property-default/create", "POST")
// @Api(Description="Form - PropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=500)
// @DataContract
export class PropertyDefaultPostCreate implements IReturn<PropertyDefaultSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the property default. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the property default. */
    // @DataMember(Order=2)
    public data: PropertyDefault;

    public constructor(init?: Partial<PropertyDefaultPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PropertyDefaultPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PropertyDefaultSingleResponse(); }
}

// @Route("/forms/form/property-default/save", "POST")
// @Api(Description="Form - PropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PropertyDefaultSingleResponse)", StatusCode=500)
// @DataContract
export class PropertyDefaultPostSave implements IReturn<PropertyDefaultSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the property default. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The property default to save. */
    // @DataMember(Order=2)
    public data: PropertyDefault;

    public constructor(init?: Partial<PropertyDefaultPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PropertyDefaultPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PropertyDefaultSingleResponse(); }
}

// @Route("/forms/form/property-default/validate", "POST")
// @Api(Description="Form - PropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PropertyDefaultValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PropertyDefaultValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PropertyDefaultValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PropertyDefaultValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PropertyDefaultValidationResponse)", StatusCode=500)
// @DataContract
export class PropertyDefaultPostValidate implements IReturn<PropertyDefaultValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the property default. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The property default to validate. */
    // @DataMember(Order=2)
    public data: PropertyDefault;

    public constructor(init?: Partial<PropertyDefaultPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PropertyDefaultPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PropertyDefaultValidationResponse(); }
}

// @Route("/forms/form/stage/single/id/{Id}", "GET")
// @Api(Description="Form - Stage")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=500)
// @DataContract
export class StageGetSingleById implements IReturn<StageSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the stage to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<StageGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StageGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StageSingleResponse(); }
}

// @Route("/forms/form/stage/collection", "GET")
// @Api(Description="Form - Stage")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StageCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StageCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StageCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StageCollectionResponse)", StatusCode=500)
// @DataContract
export class StageGetCollection implements IReturn<StageCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<StageGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StageGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StageCollectionResponse(); }
}

// @Route("/forms/form/stage/create", "POST")
// @Api(Description="Form - Stage")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=500)
// @DataContract
export class StagePostCreate implements IReturn<StageSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the stage. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the stage. */
    // @DataMember(Order=2)
    public data: Stage;

    public constructor(init?: Partial<StagePostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StageSingleResponse(); }
}

// @Route("/forms/form/stage/save", "POST")
// @Api(Description="Form - Stage")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StageSingleResponse)", StatusCode=500)
// @DataContract
export class StagePostSave implements IReturn<StageSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the stage. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The stage to save. */
    // @DataMember(Order=2)
    public data: Stage;

    public constructor(init?: Partial<StagePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StageSingleResponse(); }
}

// @Route("/forms/form/stage/validate", "POST")
// @Api(Description="Form - Stage")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StageValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StageValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.StageValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StageValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StageValidationResponse)", StatusCode=500)
// @DataContract
export class StagePostValidate implements IReturn<StageValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the stage. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The stage to validate. */
    // @DataMember(Order=2)
    public data: Stage;

    public constructor(init?: Partial<StagePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StageValidationResponse(); }
}

// @Route("/forms/form/stage-pricelist/single/id/{Id}", "GET")
// @Api(Description="Form - StagePricelist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=500)
// @DataContract
export class StagePricelistGetSingleById implements IReturn<StagePricelistSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the stage pricelist to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<StagePricelistGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePricelistGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StagePricelistSingleResponse(); }
}

// @Route("/forms/form/stage-pricelist/collection", "GET")
// @Api(Description="Form - StagePricelist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StagePricelistCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StagePricelistCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StagePricelistCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StagePricelistCollectionResponse)", StatusCode=500)
// @DataContract
export class StagePricelistGetCollection implements IReturn<StagePricelistCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<StagePricelistGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePricelistGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StagePricelistCollectionResponse(); }
}

// @Route("/forms/form/stage-pricelist/create", "POST")
// @Api(Description="Form - StagePricelist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=500)
// @DataContract
export class StagePricelistPostCreate implements IReturn<StagePricelistSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the stage pricelist. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the stage pricelist. */
    // @DataMember(Order=2)
    public data: StagePricelist;

    public constructor(init?: Partial<StagePricelistPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePricelistPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StagePricelistSingleResponse(); }
}

// @Route("/forms/form/stage-pricelist/save", "POST")
// @Api(Description="Form - StagePricelist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StagePricelistSingleResponse)", StatusCode=500)
// @DataContract
export class StagePricelistPostSave implements IReturn<StagePricelistSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the stage pricelist. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The stage pricelist to save. */
    // @DataMember(Order=2)
    public data: StagePricelist;

    public constructor(init?: Partial<StagePricelistPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePricelistPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StagePricelistSingleResponse(); }
}

// @Route("/forms/form/stage-pricelist/validate", "POST")
// @Api(Description="Form - StagePricelist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StagePricelistValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StagePricelistValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.StagePricelistValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StagePricelistValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StagePricelistValidationResponse)", StatusCode=500)
// @DataContract
export class StagePricelistPostValidate implements IReturn<StagePricelistValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the stage pricelist. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The stage pricelist to validate. */
    // @DataMember(Order=2)
    public data: StagePricelist;

    public constructor(init?: Partial<StagePricelistPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePricelistPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StagePricelistValidationResponse(); }
}

// @Route("/forms/form/stage-property-default/single/id/{Id}", "GET")
// @Api(Description="Form - StagePropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=500)
// @DataContract
export class StagePropertyDefaultGetSingleById implements IReturn<StagePropertyDefaultSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the stage property default to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<StagePropertyDefaultGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePropertyDefaultGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StagePropertyDefaultSingleResponse(); }
}

// @Route("/forms/form/stage-property-default/collection", "GET")
// @Api(Description="Form - StagePropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultCollectionResponse)", StatusCode=500)
// @DataContract
export class StagePropertyDefaultGetCollection implements IReturn<StagePropertyDefaultCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<StagePropertyDefaultGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePropertyDefaultGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StagePropertyDefaultCollectionResponse(); }
}

// @Route("/forms/form/stage-property-default/create", "POST")
// @Api(Description="Form - StagePropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=500)
// @DataContract
export class StagePropertyDefaultPostCreate implements IReturn<StagePropertyDefaultSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the stage property default. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the stage property default. */
    // @DataMember(Order=2)
    public data: StagePropertyDefault;

    public constructor(init?: Partial<StagePropertyDefaultPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePropertyDefaultPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StagePropertyDefaultSingleResponse(); }
}

// @Route("/forms/form/stage-property-default/save", "POST")
// @Api(Description="Form - StagePropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultSingleResponse)", StatusCode=500)
// @DataContract
export class StagePropertyDefaultPostSave implements IReturn<StagePropertyDefaultSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the stage property default. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The stage property default to save. */
    // @DataMember(Order=2)
    public data: StagePropertyDefault;

    public constructor(init?: Partial<StagePropertyDefaultPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePropertyDefaultPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StagePropertyDefaultSingleResponse(); }
}

// @Route("/forms/form/stage-property-default/validate", "POST")
// @Api(Description="Form - StagePropertyDefault")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.StagePropertyDefaultValidationResponse)", StatusCode=500)
// @DataContract
export class StagePropertyDefaultPostValidate implements IReturn<StagePropertyDefaultValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the stage property default. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The stage property default to validate. */
    // @DataMember(Order=2)
    public data: StagePropertyDefault;

    public constructor(init?: Partial<StagePropertyDefaultPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StagePropertyDefaultPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StagePropertyDefaultValidationResponse(); }
}

// @Route("/forms/form/tenant/single/id/{Id}", "GET")
// @Api(Description="Form - Tenant")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=500)
// @DataContract
export class TenantGetSingleById implements IReturn<TenantSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the tenant to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TenantGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TenantGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TenantSingleResponse(); }
}

// @Route("/forms/form/tenant/collection", "GET")
// @Api(Description="Form - Tenant")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.TenantCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.TenantCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.TenantCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.TenantCollectionResponse)", StatusCode=500)
// @DataContract
export class TenantGetCollection implements IReturn<TenantCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<TenantGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TenantGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TenantCollectionResponse(); }
}

// @Route("/forms/form/tenant/create", "POST")
// @Api(Description="Form - Tenant")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=500)
// @DataContract
export class TenantPostCreate implements IReturn<TenantSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the tenant. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the tenant. */
    // @DataMember(Order=2)
    public data: Tenant;

    public constructor(init?: Partial<TenantPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TenantPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TenantSingleResponse(); }
}

// @Route("/forms/form/tenant/save", "POST")
// @Api(Description="Form - Tenant")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.TenantSingleResponse)", StatusCode=500)
// @DataContract
export class TenantPostSave implements IReturn<TenantSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the tenant. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The tenant to save. */
    // @DataMember(Order=2)
    public data: Tenant;

    public constructor(init?: Partial<TenantPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TenantPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TenantSingleResponse(); }
}

// @Route("/forms/form/tenant/validate", "POST")
// @Api(Description="Form - Tenant")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.TenantValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.TenantValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.TenantValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.TenantValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.TenantValidationResponse)", StatusCode=500)
// @DataContract
export class TenantPostValidate implements IReturn<TenantValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the tenant. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The tenant to validate. */
    // @DataMember(Order=2)
    public data: Tenant;

    public constructor(init?: Partial<TenantPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TenantPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TenantValidationResponse(); }
}

// @Route("/forms/form/user-agent-location/single/id/{Id}", "GET")
// @Api(Description="Form - UserAgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=500)
// @DataContract
export class UserAgentLocationGetSingleById implements IReturn<UserAgentLocationSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the user agent location to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<UserAgentLocationGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserAgentLocationGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UserAgentLocationSingleResponse(); }
}

// @Route("/forms/form/user-agent-location/collection", "GET")
// @Api(Description="Form - UserAgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.UserAgentLocationCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.UserAgentLocationCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.UserAgentLocationCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.UserAgentLocationCollectionResponse)", StatusCode=500)
// @DataContract
export class UserAgentLocationGetCollection implements IReturn<UserAgentLocationCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<UserAgentLocationGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserAgentLocationGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UserAgentLocationCollectionResponse(); }
}

// @Route("/forms/form/user-agent-location/create", "POST")
// @Api(Description="Form - UserAgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=500)
// @DataContract
export class UserAgentLocationPostCreate implements IReturn<UserAgentLocationSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the user agent location. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the user agent location. */
    // @DataMember(Order=2)
    public data: UserAgentLocation;

    public constructor(init?: Partial<UserAgentLocationPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserAgentLocationPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UserAgentLocationSingleResponse(); }
}

// @Route("/forms/form/user-agent-location/save", "POST")
// @Api(Description="Form - UserAgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.UserAgentLocationSingleResponse)", StatusCode=500)
// @DataContract
export class UserAgentLocationPostSave implements IReturn<UserAgentLocationSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the user agent location. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The user agent location to save. */
    // @DataMember(Order=2)
    public data: UserAgentLocation;

    public constructor(init?: Partial<UserAgentLocationPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserAgentLocationPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UserAgentLocationSingleResponse(); }
}

// @Route("/forms/form/user-agent-location/validate", "POST")
// @Api(Description="Form - UserAgentLocation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.UserAgentLocationValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.UserAgentLocationValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.UserAgentLocationValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.UserAgentLocationValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.UserAgentLocationValidationResponse)", StatusCode=500)
// @DataContract
export class UserAgentLocationPostValidate implements IReturn<UserAgentLocationValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the user agent location. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The user agent location to validate. */
    // @DataMember(Order=2)
    public data: UserAgentLocation;

    public constructor(init?: Partial<UserAgentLocationPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserAgentLocationPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UserAgentLocationValidationResponse(); }
}

// @Route("/forms/form/user-project/single/id/{Id}", "GET")
// @Api(Description="Form - UserProject")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=500)
// @DataContract
export class UserProjectGetSingleById implements IReturn<UserProjectSingleResponse>, IDataGetSingleById
{
    [immerable] = true;

    /** @description The ID of the user project to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<UserProjectGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserProjectGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UserProjectSingleResponse(); }
}

// @Route("/forms/form/user-project/collection", "GET")
// @Api(Description="Form - UserProject")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.UserProjectCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.UserProjectCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.UserProjectCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.UserProjectCollectionResponse)", StatusCode=500)
// @DataContract
export class UserProjectGetCollection implements IReturn<UserProjectCollectionResponse>, IDataGetCollection
{
    [immerable] = true;

    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<UserProjectGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserProjectGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UserProjectCollectionResponse(); }
}

// @Route("/forms/form/user-project/create", "POST")
// @Api(Description="Form - UserProject")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=500)
// @DataContract
export class UserProjectPostCreate implements IReturn<UserProjectSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the user project. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The values to prefill on the user project. */
    // @DataMember(Order=2)
    public data: UserProject;

    public constructor(init?: Partial<UserProjectPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserProjectPostCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UserProjectSingleResponse(); }
}

// @Route("/forms/form/user-project/save", "POST")
// @Api(Description="Form - UserProject")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.UserProjectSingleResponse)", StatusCode=500)
// @DataContract
export class UserProjectPostSave implements IReturn<UserProjectSingleResponse>
{
    [immerable] = true;

    /** @description The metadata to use when creating the user project. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The user project to save. */
    // @DataMember(Order=2)
    public data: UserProject;

    public constructor(init?: Partial<UserProjectPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserProjectPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UserProjectSingleResponse(); }
}

// @Route("/forms/form/user-project/validate", "POST")
// @Api(Description="Form - UserProject")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.UserProjectValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.UserProjectValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.UserProjectValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.UserProjectValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.UserProjectValidationResponse)", StatusCode=500)
// @DataContract
export class UserProjectPostValidate implements IReturn<UserProjectValidationResponse>
{
    [immerable] = true;

    /** @description The metadata to use when validating the user project. */
    // @DataMember(Order=1)
    public metadata: { [index:string]: Object; };

    /** @description The user project to validate. */
    // @DataMember(Order=2)
    public data: UserProject;

    public constructor(init?: Partial<UserProjectPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserProjectPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UserProjectValidationResponse(); }
}

// @Route("/forms/file/view/{Id}", "GET")
export class GetFile implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<GetFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/forms/file/download/{Id}", "GET")
export class DownloadFile implements IReturn<Blob>, IGet
{
    [immerable] = true;

    public id?: number;

    public constructor(init?: Partial<DownloadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

